// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%23FFFFFF%27%3E%3Cpath d=%27M16 16v-4l5 5-5 5v-4H4v-2h12zM8 2v3.999L20 6v2H8v4L3 7l5-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.funding-account {
  max-width: 1180px;
  margin: 0 auto;
}

.funding-account__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #f4f4f430;
  margin: 6px 0 8px;
  padding-bottom: 10px;
}

body.light_theme .funding-account__header {
  border-bottom: 1px solid #f4f4f4;
}

.funding-account__title {
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.funding-account__header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.marginwallet_card {
  gap: 40px;
  align-items: start;
  justify-content: space-between;
  margin-top: 10px;
}

.funding-account__totals-label.h4 {
  font-size: 18px;
  font-weight: 600;
  color: #2e2e2e;
}

.marginwallet_card .funding-account__summary-grid {
  gap: 60px;
}

.funding-account__filters.funding-account__filters--tight.margin-acct__filters.rightsearch {
  justify-content: end;
}

.funding-account__filters.rightsearch {
  justify-content: flex-end;
}

.funding-account__pill {
  border: 1px solid #ededed08;
  background: #ffffff2b;
  color: #fdfdfd;
  padding: 8px 22px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.funding-account__pill:hover {
  opacity: 0.8;
}

body.light_theme .funding-account__pill {
  border: 1px solid #ededed;
  background: #ededed;
  color: #000;
}

.funding-account__pill--primary {
  border: 1px solid #ededed08;
  background: #ffffff2b;
  color: #fdfdfd;
  padding: 8px 22px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

body.light_theme .funding-account__pill--primary {
  border: 1px solid #ededed;
  background: #ededed;
  color: #000;
}

.funding-account__toprow {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin: 6px 0 10px;
}

.funding-account__totals-label {
  font-size: 15px;
  font-weight: 400;
  color: #858f9c;
}

.funding-account__totals-main {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 2px;
}

.funding-account__totals-num {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.03em;
}

.funding-account__totals-sub {
  font-size: 14px;
  font-weight: 400;
  color: #94a3b8;
}

.funding-account__spot-pnl {
  min-width: 220px;
  max-width: 320px;
}

.funding-account__spot-pnl .spot-pnl-analysis-link {
  font-size: 12px;
  font-weight: 500;
  color: #c99400;
  text-decoration: none;
}

.funding-account__spot-pnl .spot-pnl-analysis-link:hover {
  text-decoration: underline;
}

.funding-account__spot-pnl-sk__title {
  width: 36px;
  height: 14px;
  border-radius: 4px;
}

.funding-account__spot-pnl-sk__period {
  width: 32px;
  height: 22px;
  border-radius: 4px;
}

.funding-account__spot-pnl-sk__cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.funding-account__spot-pnl-sk__label {
  display: block;
  width: 72px;
  height: 11px;
  border-radius: 4px;
}

.funding-account__spot-pnl-sk__val {
  display: block;
  width: 96px;
  height: 16px;
  border-radius: 4px;
}

@media (max-width: 991.98px) {
  .funding-account__spot-pnl {
    width: 100%;
    max-width: none;
  }
}

.funding-account__details-btn {
  border: 1px solid #F6F6F6;
  background: #F6F6F6;
  color: #475569;
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}

.funding-account__filters {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 10px 0 12px;
}

.funding-account__search {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #e5e7eb3d;
  height: 38px;
  border-radius: 7px;
  padding: 6px 12px;
  min-width: 440px;
  background: none;
}

body.light_theme .funding-account__search {
  border: 1px solid #E5E7EB;
}

.funding-account__search i {
  color: #94a3b8;
}

.funding-account__search input {
  border: 0;
  outline: none;
  background: none;
  width: 100%;
  color: #fff;
  font-size: 13px;
}

body.light_theme .funding-account__search input {
  color: #000;
}

.funding-account__search.slide-search-box {
  min-width: unset;
  width: 38px;
  overflow: hidden;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border: none !important;
  white-space: nowrap;
}

.funding-account__search.slide-search-box.search_active {
  width: 250px;
}

.funding-account__search.slide-search-box input {
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.funding-account__search.slide-search-box.search_active input {
  opacity: 1;
  pointer-events: auto;
  transition-delay: 0.1s;
}

.funding-account__check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #c4c4c4;
}

body.light_theme .funding-account__check {
  color: #4A5565;
}

.funding-account__check input {
  width: 14px;
  height: 14px;
}

.funding-account__hintbar {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #eef2f70d;
  background: #f6f6f60f;
  color: #c9c9c9;
  border-radius: 12px;
  padding: 13px 12px;
  font-size: 12px;
  font-weight: 400;
}

body.light_theme .funding-account__hintbar {
  border: 1px solid #eef2f7;
  background: #F6F6F6;
  color: #64748b;
}

.funding-account__tablewrap {
  margin-top: 12px;
}

.dashboard_right.funding-account {
  padding: 24px 150px 32px 70px;
}

.funding-account__tablewrap {
  overflow-x: auto;
}

.funding-account__table {
  width: 100%;
  border-collapse: collapse;
  min-width: 980px;
}

.funding-account__table--margin {
  min-width: 1180px;
}

.funding-account__pair {
  font-size: 12px;
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
}

.funding-account__summarycard {
  border: 1px solid #f3f4f61f;
  border-radius: 12px;
  padding: 16px 18px;
  margin: 5px 0 18px;
}

body.light_theme .funding-account__summarycard {
  border: 1px solid #F3F4F6;
}

.funding-account__summary-top {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
}

.funding-account__summary-icons {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #94a3b8;
  font-size: 16px;
}

.funding-account__summary-main {
  margin-top: 10px;
}

.funding-account__summary-amount {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.funding-account__summary-num {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #fff;
  line-height: 1.1;
}

body.light_theme .funding-account__summary-num {
  color: #0f172a;
}

.funding-account__summary-unit {
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
}

.funding-account__summary-sub {
  margin-top: 2px;
  font-size: 15px;
  color: #94a3b8;
  font-weight: 400;
}

.funding-account__summary-pnl {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  color: #94a3b8;
}

.funding-account__summary-pnl strong {
  color: #0f172a;
  font-weight: 500;
}

.funding-account__summary-grid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.funding-account__summary-stat-k {
  font-size: 14px;
  color: #dbdbdb;
  font-weight: 400;
}

body.light_theme .funding-account__summary-stat-k {
  color: #94a3b8;
}

.funding-account__summary-stat-v {
  margin-top: 4px;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
}

.funding-account__summary-stat--right {
  text-align: right;
}

body.light_theme .funding-account__summary-stat-v {
  color: #0f172a;
}

.funding-account__filters--tight {
  margin-top: 0;
}

.funding-account__filters--spread {
  justify-content: space-between;
}

.funding-account__tabs {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 8px 0 16px;
}

.funding-account__tab {
  border: 0;
  background: transparent;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #94a3b8;
  cursor: pointer;
  position: relative;
}

.funding-account__tab.is-active {
  color: #fff;
}

body.light_theme .funding-account__tab.is-active {
  color: #0f172a;
}

.funding-account__tab.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  width: 35%;
  margin: 0 auto;
  height: 2px;
  background: #d1aa67;
  border-radius: 999px;
}

.funding-account__table--futures {
  min-width: 1180px;
}

.funding-account__table--futures-assets {
  min-width: 980px;
}

.funding-account__table--futures-positions {
  min-width: 1180px;
}

.agce-ft-acct-pos-margin {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.agce-ft-acct-pos-margin__text {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.agce-ft-acct-pos-margin__value {
  font-weight: 600;
}

.agce-ft-acct-pos-margin__mode {
  font-size: 11px;
  color: #848e9c;
}

.agce-ft-acct-pos-margin__edit {
  border: none;
  background: transparent;
  color: #848e9c;
  padding: 0;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

.agce-ft-acct-pos-margin__edit:hover {
  color: #d1aa67;
}

body.light_theme .agce-ft-acct-pos-margin__mode,
body.light_theme .agce-ft-acct-pos-margin__edit {
  color: #9a9da3;
}

body.light_theme .agce-ft-acct-pos-margin__edit:hover {
  color: #d1aa67;
}

.funding-account__table--futures-positions tbody td {
  vertical-align: top;
}

.funding-account__table--futures-positions .small.text-muted {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}

.funding-account__table--futures-positions .funding-account__coin-sym {
  font-weight: 600;
}

.funding-account__table thead th {
  padding: 12px 14px;
  font-size: 12px;
  font-weight: 500;
  color: #8E939C;
  text-align: left;
  border-bottom: 1px solid #f3f4f61f;
  white-space: nowrap;
}

body.light_theme .funding-account__table thead th {
  border-bottom: 1px solid #F3F4F6;
}

.funding-account__table thead th.ta-r {
  text-align: right;
}

.funding-account__table tbody td {
  padding: 12px 14px;
  border-top: 1px solid #f1f5f91f;
  vertical-align: middle;
  font-size: 13px;
}

body.light_theme .funding-account__table tbody td {
  border-top: 1px solid #f1f5f9;
}

.ta-r {
  text-align: right;
}

.funding-account__coin {
  display: flex;
  align-items: center;
  gap: 7px;
}

.funding-account__coin-dot {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: radial-gradient(circle at 30% 30%, #4b5563, #111827);
  display: inline-block;
}

.agce-ao-sheet__brand .funding-account__coin-dot.agce-ao-sheet__coin-dot {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
}

.funding-account__coin-img {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  object-fit: cover;
  flex-shrink: 0;
}

.funding-account__coin-sym {
  font-size: 14px;
  font-weight: 500;
}

label.funding-account__check.smallkcs {
  color: #AC8A50;
}

button.btn.margin-modal-btn-cancel {
  width: 50%;
}

button.btn.margin-modal-btn-confirm {
  color: #000000;
  background: #d1aa67;
}

.funding-account__coin-name {
  font-size: 14px;
  color: #f0f0f0;
  font-weight: 500;
}

body.light_theme .funding-account__coin-name {
  color: #0f172a;
}

.funding-account__num {
  font-size: 14px;
  font-weight: 500;
  color: #efefef;
}

body.light_theme .funding-account__num {
  color: #000;
}

.funding-account__subnum {
  font-size: 14px;
  color: #f3f3f3;
  font-weight: 400;
  margin-top: 2px;
}

body.light_theme .funding-account__subnum {
  color: #000;
}

.funding-account__actions {
  display: inline-flex;
  gap: 14px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.funding-account__action {
  font-size: 12px;
  /* font-weight: 600; */
  color: #f1f1f1;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
}

body.light_theme .funding-account__action {
  color: #262933;
}

.funding-account__action--btn {
  border: 0;
  background: transparent;
  padding: 0;
}

.funding-account__action:hover {
  text-decoration: underline;
  color: #e9e9e9;
}


body.light_theme .funding-account__action:hover {
  color: #262933;
}


/* Margin Borrow/Repay Modal Redesign */
.margin-modal-tabs {
  display: flex;
  gap: 32px;
  width: 100%;
}

.margin-modal-tab-wrapper {
  position: relative;
  font-size: 16px;
  font-weight: 600;
  color: #707A8A;
  cursor: pointer;
  padding-bottom: 8px;
  transition: color 0.2s;
}

.margin-modal-tab-wrapper.margin-modal-tab--active {
  color: #1E2329;
}

/* Dark mode adjustment */
.dark-theme .margin-modal-tab-wrapper.margin-modal-tab--active {
  color: #EAECEF;
}

.margin-modal-tab-indicator {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 4px;
  background-color: #FCD535;
  border-radius: 2px;
}

.margin-type-toggle-container {
  display: flex;
  margin-bottom: 24px;
}

.margin-type-toggle {
  display: inline-flex;
  background-color: #F5F5F5;
  border-radius: 8px;
  padding: 4px;
}

.dark-theme .margin-type-toggle {
  background-color: #2B3139;
}

.margin-type-toggle-btn {
  padding: 6px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #707A8A;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.margin-type-toggle-btn.active {
  background-color: #FFFFFF;
  color: #1E2329;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.dark-theme .margin-type-toggle-btn.active {
  background-color: #3B444F;
  color: #EAECEF;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.margin-modal-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  text-align: center;
}

.margin-modal-empty-icon {
  margin-bottom: 24px;
}

.margin-modal-empty-text {
  font-size: 14px;
  color: #707A8A;
  max-width: 300px;
  margin-bottom: 24px;
  line-height: 1.5;
}

.margin-modal-transfer-btn {
  background-color: #2c2c2c !important;
  color: #ffffff !important;
  font-weight: 600 !important;
  padding: 8px 48px !important;
  border-radius: 8px !important;
  border: none !important;
  font-size: 15px !important;
  min-width: 240px;
}

.margin-modal-transfer-btn:hover {
  opacity: 0.9;
}

/* Override existing cancel/confirm for the new full width style */
.margin-modal-actions {
  display: flex;
  gap: 16px;
  margin-top: 24px;
}

.margin-modal-actions .btn {
  border-radius: 8px !important;
  padding: 12px !important;
  font-weight: 600 !important;
  font-size: 16px !important;
}

/* Modern Form Overrides */
.modern-margin-form .margin-coin-radios {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  margin-bottom: 24px;
}

.modern-margin-form .margin-coin-pill {
  flex: 1 1;
  text-align: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #F5F5F5;
  color: #1E2329;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.dark-theme .modern-margin-form .margin-coin-pill {
  background-color: #2B3139;
  color: #EAECEF;
}

.modern-margin-form .margin-coin-pill.active {
  background-color: #FFFFFF;
}

.dark-theme .modern-margin-form .margin-coin-pill.active {
  background-color: #1E2329;
}

.modern-margin-form .price_max_total {
  /* background-color: #F5F5F5 !important; */
  border: 1px solid transparent !important;
  border-radius: 8px !important;
  padding: 4px 12px !important;
}

.dark-theme .modern-margin-form .price_max_total {
  background-color: #2B3139 !important;
}

.modern-margin-form .price_max_total input {
  background-color: transparent !important;
}

.modern-margin-form .margin-modal-actions .btn-cancel-modern {
  background-color: #EAECEF !important;
  color: #1E2329 !important;
}

.modern-margin-form .margin-modal-actions .btn-confirm-modern {
  background-color: #2c2c2c !important;
  color: #ffffff !important;
}

.modern-margin-form .margin-modal-actions .btn-confirm-modern:hover {
  opacity: 0.9;
}

.dark-theme .modern-margin-form .margin-modal-actions .btn-cancel-modern {
  background-color: #2B3139 !important;
  color: #EAECEF !important;
}

/* Margin Borrow Repay Modal Styles */
.margin-modal-container .modal-content {
  border-radius: 24px;
}

.margin-modal-container .margin-modal-tabs {
  display: flex;
  gap: 24px;
  /* margin-bottom: 20px; */
}

.margin-modal-legend {
  font-size: 15px !important;
}

.margin-modal-container .margin-modal-tab-wrapper {
  position: relative;
  font-size: 18px;
  font-weight: 600;
  color: #707A8A;
  padding-bottom: 12px;
  cursor: pointer;
}

.margin-modal-container .margin-modal-tab-wrapper.active {
  font-weight: 700;
  color: #ffffff;
}

body.light_theme .margin-modal-container .margin-modal-tab-wrapper.active {
  color: #1E2329;
}

.margin-modal-container .margin-modal-tab-indicator {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 42px;
  height: 3px;
  background-color: #d1aa67;
  border-radius: 2px;
}

.margin-modal-container .margin-modal-close {
  align-self: flex-start;
}

.margin-modal-container .margin-type-toggle-container {
  display: flex;
  width: 100%;
  margin-bottom: 24px;
  border-radius: 8px;
  border: 1px solid #EAECEF;
  padding: 2px;
}

.margin-modal-container .margin-type-toggle {
  flex: 1 1;
  text-align: center;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  color: #8c8c8c;
  background-color: transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.margin-modal-container .margin-type-toggle.active {
  font-weight: 600;
  color: #1E2329;
  background-color: #F5F5F5;
}

.margin-modal-container .repay-label {
  font-size: 13px;
  color: #707A8A;
  margin-bottom: 8px;
  display: block;
  font-weight: 500;
}

.margin-modal-container .repay-input-container {
  position: relative;
}

.margin-modal-container .repay-input-wrapper {
  border: 1px solid #eaecef17;
  border-radius: 8px;
  display: flex;
  align-items: center;
  background-color: #ffffff1a;

}

body.light_theme .margin-modal-container .repay-input-wrapper {
  border: 1px solid #EAECEF;
  background-color: #FFFFFF;
}

.margin-modal-container .coin-dropdown-trigger {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border-right: 1px solid #eaecef17;
}

body.light_theme .margin-modal-container .coin-dropdown-trigger {
  border-right: 1px solid #EAECEF;
}

.margin-modal-container .coin-icon-small {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #F0F0F0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.margin-modal-container .coin-icon-text {
  font-size: 9px;
  font-weight: bold;
  color: #707A8A;
}

.margin-modal-container .coin-symbol {
  font-weight: 600;
  color: #ffffff;
  font-size: 14px;
}

.funding-account__table tr:hover {
  box-shadow: 0px 0px 20px #f3ba2b14;
  background-color: rgb(54 54 54 / 11%);
}

.funding-account__table tr {
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  border-left: none !important;
}

body.light_theme .margin-modal-container .coin-symbol {
  color: #1E2329;
}

.margin-modal-container .coin-dropdown-icon {
  color: #e6e6e6;
  font-size: 14px;
}

body.light_theme .margin-modal-container .coin-dropdown-icon {
  color: #707A8A;
}

.margin-modal-container .repay-nothing-text {
  flex: 1 1;
  padding: 12px 16px;
  color: #707A8A;
  font-size: 14px;
}

.margin-modal-container .repay-amount-input {
  border: none;
  outline: none;
  background: transparent;
  /* text-align: right; */
  flex: 1 1;
  width: 100%;
  padding: 12px 16px;
  color: #1E2329;
  font-weight: 500;
  font-size: 14px;
}

.dark-theme .margin-modal-container .repay-amount-input {
  color: #EAECEF;
}

.margin-modal-container .search-input-wrapper {
  position: relative;
}

.margin-modal-container .isolated-pair-popover {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #25282e;
  border: 1px solid #eaecef17;
  border-radius: 8px;
  margin-top: 4px;
  z-index: 10;
  max-height: 300px;
  display: flex;
  flex-direction: column;
}

body.light_theme .margin-modal-container .isolated-pair-popover {
  background-color: #FFFFFF;
  border: 1px solid #EAECEF;
}

.margin-modal-container .search-header {
  border-bottom: 1px solid #eaecef17;
}

body.light_theme .margin-modal-container .search-header {
  border-bottom: 1px solid #EAECEF;
}

.margin-modal-container .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #707A8A;
}

.margin-modal-container .search-input {
  width: 100%;
  padding: 8px 12px 8px 36px;
  border: 1px solid #eaecef17;
  background-color: #181a20;
  color: #ffffff;
  border-radius: 8px;
  outline: none;
  font-size: 14px;
}

body.light_theme .margin-modal-container .search-input {
  border: 1px solid #EAECEF;
  background-color: #FFFFFF;
  color: #1E2329;
}

.margin-modal-container .popover-list {
  overflow-y: auto;
  flex: 1 1;
  padding: 8px 0;
}

.margin-modal-container .isolated-pair-option {
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: transparent;
}

.margin-modal-container .isolated-pair-option:hover {
  background-color: #ffffff14;
}

.margin-modal-container .isolated-pair-option.active {
  background-color: #ffffff1f;
}

body.light_theme .margin-modal-container .isolated-pair-option:hover {
  background-color: #F5F5F5;
}

body.light_theme .margin-modal-container .isolated-pair-option.active {
  background-color: #F5F5F5;
}

.margin-modal-container .coin-info-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.margin-modal-container .coin-icon-medium {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #F0F0F0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.margin-modal-container .coin-icon-text-medium {
  font-size: 10px;
  font-weight: bold;
  color: #707A8A;
}

.margin-modal-container .coin-text-group {
  display: flex;
  flex-direction: column;
}

.margin-modal-container .coin-name {
  font-weight: 500;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.2;
}

body.light_theme .margin-modal-container .coin-name {
  color: #1E2329;
}

.margin-modal-container .coin-fullname {
  color: #707A8A;
  font-size: 12px;
  margin-top: 2px;
}

.margin-modal-container .coin-balance-group {
  text-align: right;
  font-size: 13px;
  color: #707A8A;
}

.margin-modal-container .coin-balance-val {
  color: #ffffff;
}

body.light_theme .margin-modal-container .coin-balance-val {
  color: #1E2329;
}

.margin-modal-container .margin-modal-empty-note {
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: #2b313d;
  padding: 12px 16px;
  border-radius: 8px;
  color: #f1f1f1;
  font-size: 13px;
  line-height: 1.5;
}

body.light_theme .margin-modal-container .margin-modal-empty-note {
  background-color: #F5F5F5;
  color: #1E2329;
}

.margin-modal-container .empty-note-icon {
  font-size: 16px;
  margin-top: 1px;
}

.margin-modal-container .isolated-pair-selector-wrap {
  position: relative;
}

.margin-modal-container .isolated-pair-input {
  /* border: 1px solid #eaecef17; */
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: #2b313d;
}

body.light_theme .margin-modal-container .isolated-pair-input {
  border: 1px solid #EAECEF;
  background-color: #FFFFFF;
}

.margin-modal-container .margin-coin-radios {
  display: flex;
  gap: 12px;
}

.margin-modal-container .borrow-input-wrapper {
  border: 1px solid #EAECEF;
  border-radius: 8px;
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  padding: 12px 16px;
  margin-bottom: 8px;
}

.margin-modal-container .borrow-input {
  border: none;
  outline: none;
  flex: 1 1;
  font-size: 14px;
  color: #1E2329;
  background-color: transparent;
}

.margin-modal-container .max-borrow-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #707A8A;
  margin-bottom: 16px;
}

.margin-modal-container .max-borrow-btn {
  color: #FCD535;
  cursor: pointer;
  font-weight: 500;
}

.margin-modal-container .margin-modal-actions {
  display: flex;
  gap: 12px;
}

.margin-modal-container .btn-cancel-modern {
  flex: 1 1;
  padding: 12px;
  border: 1px solid #EAECEF;
  border-radius: 8px;
  background-color: #FFFFFF;
  font-weight: 600;
}

.margin-modal-container .btn-confirm-modern {
  flex: 1 1;
  padding: 12px;
  border: none;
  border-radius: 8px;
  background-color: #FCD535;
  color: #1E2329;
  font-weight: 600;
}

.margin-modal-container .isolated-coin-card {
  flex: 1 1;
  padding: 16px;
  /* border: 1px solid #eaecef1f; */
  border-radius: 4px;
  text-align: left;
  cursor: pointer;
  background-color: #2b313d;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.margin-modal-container .isolated-coin-card span {
  color: #fff !important;
}

body.light_theme .margin-modal-container .isolated-coin-card span {
  color: #070707 !important;
}

body.light_theme .margin-modal-container .isolated-coin-card {
  border: 1px solid #EAECEF;
  background-color: #ffffff70;
}

.margin-modal-container .isolated-coin-card.active {
  border: 1px solid #d1aa67;
}

.margin-modal-container .coin-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.margin-modal-container .coin-card-body {
  display: flex;
  flex-direction: column;
  margin-left: 28px;
}

.margin-modal-container .margin-info-rows {
  font-size: 13px;
  color: #707A8A;
}

.margin-modal-container .margin-info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.margin-modal-container .margin-info-val {
  color: #1E2329;
  font-weight: 500;
}

.margin-modal-container .margin-info-val.red {
  color: #e45561;
}

.margin-modal-container .margin-info-total {
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
  border-top: 1px solid #EAECEF;
  margin-bottom: 8px;
}

.margin-modal-container .margin-info-total-val {
  color: #1E2329;
  font-weight: 600;
}

.margin-modal-container .repay-full-checkbox {
  width: 14px;
  height: 14px;
  accent-color: #FCD535;
}

.margin-modal-container .repay-full-label {
  cursor: pointer;
  font-size: 13px;
  color: #1E2329;
}





/* ---- /user_profile/wallet/* : center no-data vector while loading or empty ---- */
.agce-wallet-page--initial .agce-wallet-empty-canvas {
  min-height: min(70vh, 560px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.agce-wallet-page--initial .agce-wallet-empty-canvas .no-data-wrapper {
  min-height: 200px;
}

.agce-wallet-empty-canvas__hint {
  font-size: 14px;
  color: #64748b;
}

body:not(.light_theme) .agce-wallet-empty-canvas__hint {
  color: #94a3b8;
}

/* Spot wallet: tablewrap has no .table-responsive; flex-fill so empty row can center */
.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap:has(tr.no-data-row),
.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap:has(tr.no-data-row2) {
  display: flex;
  flex-direction: column;
  min-height: min(52vh, 420px);
}

.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap:has(tr.no-data-row) .funding-account__table,
.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap:has(tr.no-data-row2) .funding-account__table {
  flex: 1 1 auto;
  width: 100%;
  min-height: min(48vh, 400px);
}

.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr.no-data-row td,
.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr.no-data-row2 td {
  height: 100%;
  min-height: min(46vh, 360px);
  vertical-align: middle !important;
  text-align: center !important;
}

.dashboard_right.funding-account.wallet-page--ao-popup tr.no-data-row .no-data-wrapper,
.dashboard_right.funding-account.wallet-page--ao-popup tr.no-data-row2 .no-data-wrapper {
  min-height: min(42vh, 320px);
}

/* Non-spot wallet: reinforce centering alongside global .table-responsive:has(.no-data-row) */
.dashboard_right.funding-account.wallet-nonspot .dashboard_summary:has(tr.no-data-row),
.dashboard_right.funding-account.wallet-nonspot .dashboard_summary:has(tr.no-data-row2) {
  min-height: min(52vh, 420px);
}

.dashboard_right.funding-account.wallet-nonspot .dashboard_summary .table-responsive:has(tr.no-data-row),
.dashboard_right.funding-account.wallet-nonspot .dashboard_summary .table-responsive:has(tr.no-data-row2) {
  min-height: min(48vh, 400px);
}

.dashboard_right.funding-account.wallet-nonspot .dashboard_summary tr.no-data-row td,
.dashboard_right.funding-account.wallet-nonspot .dashboard_summary tr.no-data-row2 td {
  min-height: min(46vh, 360px);
  vertical-align: middle !important;
  text-align: center !important;
}

.dashboard_right.funding-account.wallet-nonspot tr.no-data-row .no-data-wrapper,
.dashboard_right.funding-account.wallet-nonspot tr.no-data-row2 .no-data-wrapper {
  min-height: min(42vh, 320px);
}

.margin-mmr-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 1px 6px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  background: #d1fae5;
  color: #065f46;
}

body.dark_theme .margin-mmr-badge {
  background: #064e3b;
  color: #6ee7b7;
}

/* Margin Pro Page - Ultra Premium Design (Pure CSS Override) */
.margin-pro-page {
  padding-top: 32px !important;
  background: #ffffff00;
}

body.light_theme .margin-pro-page {
  background: #FFFFFF;
}

.margin-pro-page .funding-account__header {
  margin: 24px 0 32px;
  padding: 0;
  border-bottom: none;
}

.margin-pro-page .funding-account__title {
  font-size: 32px;
}

/* .margin-pro-page .funding-account__header>div:first-child::after {
  content: "Manage your isolated margin positions and assets";
  display: block;
  font-size: 14px;
  color: #707A8A;
  margin-top: 4px;
  font-weight: 400;
} */

.margin-pro-page .funding-account__pill {
  background-color: #303135;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}

.margin-pro-page .funding-account__pill::before {
  filter: invert(0);
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

body.light_theme .margin-pro-page .funding-account__pill::before {
  filter: invert(1);
}

/* Summary Card Overrides */
.margin-pro-page .funding-account__summarycard {
  border: 1px solid #e5e7eb26;
  background: #FFFFFF00;
  border-radius: 12px;
  padding: 24px;
  margin: 0 0 24px 0;
  box-shadow: none;
}

body.light_theme .margin-pro-page .funding-account__summarycard {
  border: 1px solid #EAECEF;
  background: #FFFFFF;
}

.margin-pro-page .funding-account__summary-top {
  margin-bottom: 16px;
}

.margin-pro-page .funding-account__totals-label {
  font-size: 14px;
  font-weight: 600;
  color: #eeeeee;
  display: flex;
  align-items: center;
  gap: 6px;
}

body.light_theme .margin-pro-page .funding-account__totals-label {
  color: #1E2329;
}

.margin-pro-page .marginwallet_card {
  align-items: center;
  margin-top: 0;
  gap: 0;
}

.margin-pro-page .funding-account__summary-main {
  flex: 1 1;
  /* border-right: 1px solid #EAECEF; */
  padding-right: 24px;
  margin-top: 0;
}

.margin-pro-page .funding-account__summary-amount {
  align-items: baseline;
  gap: 8px;
  margin-bottom: 4px;
}

.margin-pro-page .funding-account__summary-num {
  font-size: 32px;
  font-weight: 700;
  color: #f0f0f0;
}

body.light_theme .margin-pro-page .funding-account__summary-num {
  color: #1E2329;
}

.margin-pro-page .funding-account__summary-unit {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
}

body.light_theme .margin-pro-page .funding-account__summary-unit {
  color: #1E2329;
}

.margin-pro-page .funding-account__summary-sub {
  font-size: 13px;
  color: #707A8A;
  margin-bottom: 24px;
}

.margin-pro-page .funding-account__summary-pnl {
  font-size: 13px;
  color: #707A8A;
  display: flex;
  align-items: center;
  gap: 6px;
}

.margin-pro-page .funding-account__summary-pnl span {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* .margin-pro-page .funding-account__summary-pnl span::after {
  content: "";
  display: inline-block;
  width: 14px;
  height: 14px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23707A8A'%3E%3Cpath d='M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z'/%3E%3C/svg%3E");
} */

.margin-pro-page .funding-account__summary-pnl strong {
  color: #F6465D;
  font-weight: 500;
}

.margin-pro-page .funding-account__summary-grid {
  flex: 1 1;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-left: 24px;
  gap: 0;
}

.margin-pro-page .funding-account__summary-stat {
  display: flex;
  width: 50%;
  flex-direction: column;
  text-align: left;
  border-left: 1px solid #eaecef33;
  padding-left: 40px;
  padding-right: 30px;
}

body.light_theme .margin-pro-page .funding-account__summary-stat {
  border-left: 1px solid #EAECEF;
}

.margin-pro-page .funding-account__summary-stat-k {
  font-size: 13px;
  color: #f5f5f5;
  margin-bottom: 12px;
  font-weight: 400;
}

body.light_theme .margin-pro-page .funding-account__summary-stat-k {
  color: #1E2329;
}

.margin-pro-page .funding-account__summary-stat-v {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 8px;
  display: flex;
  align-items: baseline;
  gap: 4px;
}

body.light_theme .margin-pro-page .funding-account__summary-stat-v {
  color: #1E2329;
}

.margin-pro-page .funding-account__summary-stat-v span {
  font-size: 12px;
  color: #707A8A;
  font-weight: 400;
}

.margin-pro-page .funding-account__summary-stat::after {
  content: "";
  display: block;
  height: 2px;
  border-radius: 2px;
  width: 40px;
  background-color: #c1c1c1;
}

.margin-pro-page .funding-account__summary-stat--right::after {
  background-color: #EAECEF;
}

/* Filter Card Overrides */
.margin-pro-page .funding-account__card {
  background: none;
  margin-top: 16px;
  padding: 0;
  box-shadow: none;
}

.margin-pro-page .funding-account__filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
}

.margin-pro-page .funding-account__search {
  display: flex;
  align-items: center;
  border: 1px solid #EAECEF;
  border-radius: 8px;
  padding: 0 12px;
  height: 36px;
  background: #ffffff14;
}

body.light_theme .margin-pro-page .funding-account__search {
  background: #FFFFFF;
}

.margin-pro-page .funding-account__search i {
  color: #707A8A;
  font-size: 16px;
  margin-right: 8px;
}

.margin-pro-page .funding-account__search input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 13px;
  color: #ebebeb;
  background: transparent;
}

body.light_theme .margin-pro-page .funding-account__search input {
  color: #1E2329;
}

/* Custom checkbox */
.margin-pro-page .funding-account__check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #d3d3d3;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 400;
  margin-left: 24px;
}

body.light_theme .margin-pro-page .funding-account__check {
  color: #1E2329;
}

.margin-pro-page .funding-account__check input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  background-color: #FFFFFF;
  border: 1px solid #B7BDC6;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
  margin: 0;
  transition: all 0.2s;
}

.margin-pro-page .funding-account__check:hover input[type="checkbox"] {
  border-color: #848E9C;
}

.margin-pro-page .funding-account__check input[type="checkbox"]:checked {
  background-color: #FCD535;
  border-color: #FCD535;
}

.margin-pro-page .funding-account__check:last-child input[type="checkbox"]:checked {
  background-color: #1E2329;
  border-color: #1E2329;
}

.margin-pro-page .funding-account__check input[type="checkbox"]:checked::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #1E2329;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.margin-pro-page .funding-account__check:last-child input[type="checkbox"]:checked::after {
  border-color: #FFFFFF;
}


/* Dark mode overrides */
body.dark .margin-pro-page,
body.dark .margin-pro-page .funding-account__summarycard,
body.dark .margin-pro-page .funding-account__card,
body.dark .margin-pro-page .funding-account__search {
  background-color: #181A20;
  border-color: #2B3139;
}

body.dark .margin-pro-page .funding-account__title,
body.dark .margin-pro-page .funding-account__totals-label,
body.dark .margin-pro-page .funding-account__summary-num,
body.dark .margin-pro-page .funding-account__summary-unit,
body.dark .margin-pro-page .funding-account__summary-stat-k,
body.dark .margin-pro-page .funding-account__summary-stat-v,
body.dark .margin-pro-page .funding-account__check,
body.dark .margin-pro-page .funding-account__search input {
  color: #EAECEF;
}

body.dark .margin-pro-page .funding-account__summary-main,
body.dark .margin-pro-page .funding-account__filters {
  border-color: #2B3139;
}

body.dark .margin-pro-page .funding-account__pill {
  background: #FCD535;
  color: #181A20;
}

/* Table Styles (Matching Clean Design) */
.margin-pro-page .funding-account__tablewrap {
  background: transparent;
  padding: 0;
  margin-top: 16px;
}

.margin-pro-page .funding-account__table {
  width: 100%;
  border-collapse: collapse;
}

.margin-pro-page .funding-account__table th {
  padding: 10px 8px;
  font-size: 12px;
  font-weight: 500;
  color: #8E939C;
  border-bottom: none;
  text-align: left;
}

.margin-pro-page .funding-account__table th:first-child {
  padding-left: 16px;
}

.margin-pro-page .funding-account__table th:last-child {
  padding-right: 16px;
}

.margin-pro-page .funding-account__table th.ta-r {
  text-align: right;
}

.margin-pro-page .funding-account__table td {
  padding: 16px 8px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  border-bottom: none;
  vertical-align: middle;
}

body.light_theme .margin-pro-page .funding-account__table td {
  color: #1E2329;
}

.margin-pro-page .funding-account__table td:first-child {
  padding-left: 16px;
}

.margin-pro-page .funding-account__table td:last-child {
  padding-right: 16px;
}

.margin-pro-page .funding-account__table tbody tr:last-child td {
  border-bottom: none;
}

/* Pair & Coin Styling */
.margin-pro-page .funding-account__coin-img {
  width: 28px;
  height: 28px;
  margin-right: 0px;
  border-radius: 50%;
}

.margin-pro-page .funding-account__pair {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #1E2329;
}

.margin-pro-page .funding-account__coin-name {
  font-size: 13px;
  font-weight: 500;
  color: #707A8A;
}

.margin-pro-page .funding-account__num {
  font-size: 14px;
  font-weight: 500;
  color: #e3e3e3;
}

body.light_theme .margin-pro-page .funding-account__num {
  color: #1E2329;
}

body.dark .margin-pro-page .funding-account__pair .agce-margin-level-value {
  color: inherit;
}

.margin-pro-page .funding-account__pair .agce-margin-level--normal,
.margin-pro-page .funding-account__pair .agce-margin-level--safe {
  color: #16a34a !important;
}

.margin-pro-page .funding-account__pair .agce-margin-level--margin_call {
  color: #d97706 !important;
}

.margin-pro-page .funding-account__pair .agce-margin-level--liquidated {
  color: #dc2626 !important;
}

.margin-pro-page .funding-account__pair .agce-margin-level--unavailable {
  color: #9ca3af !important;
}

.margin-pro-page .margin-mmr-badge {
  background: #E8F5E9;
  color: #0CAF60;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  margin-top: 4px;
  display: inline-block;
}

/* Action Buttons (Plain Text) */
.margin-pro-page .funding-account__actions {
  display: flex;
  gap: 16px;
  justify-content: flex-end;
}

.margin-pro-page .funding-account__action {
  background: transparent;
  border: none;
  font-size: 12px;
  /* font-weight: 600; */
  color: #e9e9e9;
  cursor: pointer;
  padding: 0;
}

body.light_theme .margin-pro-page .funding-account__action {
  color: #262933;
}

.margin-pro-page .funding-account__action:hover {
  text-decoration: underline;
}

/* Dark mode overrides for table */
body.dark .margin-pro-page .funding-account__table th {
  color: #5E6673;
  border-bottom-color: #2B3139;
}

body.dark .margin-pro-page .funding-account__table td {
  color: #EAECEF;
  border-bottom-color: #2B3139;
}

body.dark .margin-pro-page .funding-account__pair,
body.dark .margin-pro-page .funding-account__num {
  color: #EAECEF;
}

body.dark .margin-pro-page .funding-account__coin-name {
  color: #848E9C;
}

body.dark .margin-pro-page .funding-account__action {
  color: #848E9C;
}

body.dark .margin-pro-page .funding-account__action:hover {
  color: #EAECEF;
}


/* ── Margin Borrow/Repay modal ─────────────────────────────── */
.margin-modal-tabs {
  display: flex;
  gap: 24px;
  align-items: flex-end;
}

.margin-modal-tab {
  font-size: 18px;
  font-weight: 700;
  color: #aaa;
  cursor: pointer;
  /* padding-bottom: 2px; */
}

.margin-modal-tab--active {
  font-weight: 700;
  color: inherit;
  /* border-bottom: 2px solid currentColor; */
}

.margin-modal-subtitle {
  font-size: 13px;
  color: #888;
  margin-bottom: 4px;
}

.margin-modal-info-link {
  font-size: 13px;
  color: #1677ff;
  display: inline-block;
  margin-bottom: 16px;
  text-decoration: none;
}

.margin-pair-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

/* ── Cross Margin Page Helper Classes (No Inline Styles) ─────────────────────────────── */
.cmp-mb-4 {
  margin-bottom: 4px;
}

.cmp-balance-val {
  font-size: 28px;
  line-height: 1.1;
}

.cmp-balance-val-mobile {
  font-size: 26px;
  line-height: 1.1;
}

.cmp-currency-label {
  font-size: 14px;
  color: #8E949E;
}

.cmp-balance-fiat {
  font-size: 13px;
  color: #8E949E;
  margin-top: 2px;
}

.cmp-margin-gauge-label {
  font-size: 12px;
  color: #8E949E;
  margin-bottom: 2px;
  font-weight: 500;
}

.cmp-flex-center-gap-6 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.cmp-cross-leverage {
  font-size: 14px;
  font-weight: 600;
  color: #f59e0b;
}

.cmp-cross-leverage-mobile {
  font-size: 13px;
  font-weight: 600;
  color: #f59e0b;
}

.cmp-risk-badge {
  font-size: 11px;
}

.cmp-risk-badge-mobile {
  font-size: 10px;
}

.cmp-stat-subtext {
  font-size: 11px;
  color: #8E949E;
}

.cmp-stat-val {
  font-size: 18px;
  font-weight: 600;
}

.cmp-text-danger {
  color: #e45561 !important;
}

.cmp-text-warning {
  color: #f59e0b !important;
}

.cmp-text-success {
  color: #01bc8d !important;
}

.cmp-text-muted {
  color: #8E949E !important;
}

.cmp-text-inherit {
  color: inherit;
}

.cmp-mobile-row-divider {
  border-top: 1px solid rgba(128, 128, 128, 0.12);
  padding-top: 14px;
}

.cmp-mobile-margin-gauge-title {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.cmp-mobile-margin-gauge-val {
  font-size: 15px;
  font-weight: 700;
}

.cmp-pnl-title {
  font-size: 13px;
  font-weight: 700;
}

.cmp-pnl-btn-group {
  display: flex;
  gap: 4px;
}

.cmp-pnl-btn {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  border: none;
  background: rgba(128, 128, 128, 0.12);
  color: #8E949E;
  cursor: pointer;
}

.cmp-pnl-btn.active {
  background: #0f172a;
  color: #fff;
}

body.dark .cmp-pnl-btn.active {
  background: #fff;
  color: #000;
}

.cmp-pnl-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
}

.cmp-pnl-label {
  font-size: 11px;
  color: #ebebeb;
}

body.light_theme .cmp-pnl-label {
  color: #8E949E;
}

.cmp-pnl-val {
  font-size: 14px;
  font-weight: 700;
}

.cmp-pnl-footer {
  grid-column: 1 / -1;
  font-size: 11px;
  color: #8E949E;
  margin-top: 2px;
}

.cmp-loading-text {
  font-size: 12px;
  color: #8E949E;
}

.cmp-flex-1-center {
  flex: 1 1;
  justify-content: center;
}

.cmp-mobile-actions-row {
  display: flex;
  gap: 10px;
}

.cmp-tabs-header {
  /* border-bottom: 1px solid rgba(128, 128, 128, 0.15); */
  padding: 0 0px;
}

.cmp-tabs-group {
  display: flex;
  gap: 20px;
}

.cmp-tab-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #ffffff8c;
  padding: 12px 0px 10px;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
}

body.light_theme .cmp-tab-btn {
  color: #242424;
}

.cmp-tab-btn.active {
  font-weight: 600;
  color: inherit;
}

.cmp-py-8 {
  padding: 8px 0;
}

.cmp-search-box {
  min-width: 160px;
}

.cmp-mobile-filter-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 0;
}

.cmp-w-100 {
  width: 100%;
}

.cmp-checkbox-label {
  font-size: 15px;
}

.cmp-mobile-filter-actions {
  display: flex;
  gap: 10px;
  padding-top: 10px;
}

.so-filtersModal--filters .modal-footer {
  border: none;
  padding: 20px;
}

.so-filtersModal--filters .modal-body {
  padding: 20px;
}

.so-filtersModal--filters .modal-header {
  padding: 20px 20px 10px;
  border: none;
}

.modal.agce-ao-sheet-modal .agce-ao-sheet__header {
  border-bottom: none;
}

.modal.agce-ao-sheet-modal .agce-ao-sheet__divider {
  display: none;
}

.modal.agce-ao-sheet-modal .agce-ao-sheet__kv {
  font-size: 14px;
}

.modal.agce-ao-sheet-modal .agce-ao-sheet__hero-num {
  font-size: 24px;
  margin-bottom: 18px;
}

.cmp-flex-1 {
  flex: 1 1;
}

.cmp-table-wrap {
  min-height: 320px;
}

.cmp-interest-badge {
  color: #e45561;
  font-size: 11px;
}

.cmp-borrowed-val.has-borrow {
  color: #e45561;
}

.cmp-relative-inline {
  position: relative;
  display: inline-block;
}

.cmp-help-text {
  cursor: help;
  color: #8e949e;
  font-size: 13px;
  padding: 8px 4px;
  display: inline-block;
}

.cmp-close-btn {
  color: #e45561 !important;
  border-color: #e45561 !important;
  cursor: pointer;
  pointer-events: auto;
}

.cmp-close-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.cmp-side-badge {
  font-size: 11px;
  font-weight: 700;
  border-radius: 3px;
  padding: 1px 5px;
}

.cmp-side-badge--long {
  color: #01bc8d;
  border: 1px solid #01bc8d;
}

.cmp-side-badge--short {
  color: #e45561;
  border: 1px solid #e45561;
}

.cmp-z-1060 {
  z-index: 1060;
}

.margin-coin-radios {
  display: flex;
  gap: 24px;
  margin: 12px 0;
}

.funding-account__summarycard.border-0 {
  padding: 0px;
  border-radius: 0px;
}

.crossmargintop {
  border: 1px solid #e5e7eb26;
  border-radius: 12px;
  background: #ffffff00;
  padding: 24px;
  margin: 0 0 24px 0;
  box-shadow: none;
}

body.light_theme .crossmargintop {
  border: 1px solid #EAECEF;
  background: #FFFFFF;
}

.funding_acount_block_margin {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  border: 1px solid #eaecef29;
  border-radius: 12px;
  background: #ffffff00;
  padding: 24px;
  margin: 0 0 24px 0;
  box-shadow: none;
}

body.light_theme .funding_acount_block_margin {
  border: 1px solid #EAECEF;
  background: #FFFFFF;
}

.so-filtersModal--filters {
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

.modal-content {
  box-shadow: 0px 5px 15px #00000026;
  border: var(--bs-modal-border-width) solid rgb(0 0 0 / 9%);
}

.margin-coin-radio {
  color: rgb(230, 230, 230);
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

body.light_theme .margin-coin-radio {
  color: #0f172a;
}

.margin-info-rows {
  margin-bottom: 12px;
  margin-top: 18px;

}

.margin-info-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #888;
  margin-bottom: 6px;
}

.margin-info-row span:last-child {
  color: inherit;
}

.margin-pairs-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}

.margin-pairs-header h6 {
  margin-bottom: 0;
}

.margin-hide-zero {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #888;
  cursor: pointer;
  margin-bottom: 0;
}

.margin-modal-note {
  display: flex;
  gap: 8px;
  align-items: center;
  background: #2B313C;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 12px;
  color: #f7f7f7;
  margin: 16px 0;
}

body.light_theme .margin-modal-note {
  color: #505050;
  background: #e5e5e5;
}

.funding-account__totals-label button i {
  color: #fff;
}

body.light_theme .funding-account__totals-label button i {
  color: #000;
}

.margin-modal-note i {
  color: #3b82f6;
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 1px;
}

.margin-modal-actions {
  display: flex;
  gap: 16px;
}

.crypto_selectcoin-2 {
  margin-top: 15px !important;
}

.margin-modal-btn-cancel,
.margin-modal-btn-confirm {
  /* flex: 1; */
  border-radius: 40px;
  padding: 10px 0;
  font-size: 15px;
  font-weight: 600;
}

.margin-modal-btn-cancel {
  background: #f3f4f6;
  color: #222;
  border: none;
}

.margin-modal-btn-confirm {
  background: #f3f4f6;
  color: #222;
  border: none;
}

.margin-modal-btn-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

body.dark_theme .margin-modal-btn-cancel,
body.dark_theme .margin-modal-btn-confirm {
  background: #2d3748;
  color: #e2e8f0;
}

.margin-modal-interest-note {
  font-size: 12px;
  color: #888;
  line-height: 1.5;
  padding: 6px 0 2px;
}

body.dark_theme .margin-modal-interest-note {
  color: #9ca3af;
}

.margin-level-value {
  color: #22c55e;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 3px;
}

.margin-tier-value {
  color: #f59e0b;
  font-weight: 600;
}

.margin-pair-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #2d3138;
  border: 1px solid #ededed05;
  border-radius: 8px;
  z-index: 9999;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);
}

body.light_theme .margin-pair-dropdown {
  background: #fff;
  border: 1px solid #ededed;
}

.margin-pair-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background 0.15s;
}

.margin-pair-option:hover {
  background: #f5f5f514;
}

body.light_theme .margin-pair-option:hover {
  background: #f5f5f5;
}

.margin-pair-option--active {
  background: #f5f5f514;
  font-weight: 600;
}

body.light_theme .margin-pair-option--active {
  background: #f0f0f0;
}

div#marginBorrowRepayModal .modal-content {
  min-height: 550px;
}

body.dark_theme .margin-pair-dropdown {
  background: #1a1d27;
  border-color: #2d3748;
}

body.dark_theme .margin-pair-option:hover {
  background: #2d3748;
}

body.dark_theme .margin-pair-option--active {
  background: #2a2f3e;
}

/* No-liability / tooSmall tooltip */
.agce-no-liab-wrap {
  position: relative;
  display: inline-block;
}

.agce-no-liab-tip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: calc(100% + 8px);
  bottom: auto;
  right: 0;
  left: auto;
  transform: none;
  background: #1e293b;
  color: #f1f5f9;
  font-size: 12px;
  font-weight: 500;
  white-space: normal;
  width: 220px;
  padding: 8px 12px;
  border-radius: 7px;
  pointer-events: none;
  z-index: 99999;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  text-align: center;
  line-height: 1.55;
  transition: opacity 0.15s ease;
}

.agce-no-liab-tip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  right: 16px;
  left: auto;
  transform: none;
  border: 6px solid transparent;
  border-bottom-color: #1e293b;
}

.agce-no-liab-wrap:hover .agce-no-liab-tip {
  visibility: visible;
  opacity: 1;
}

.margin-modal-container .coin-icon-small span.coin-icon-text {
  color: #000 !important;
}


/*
 * Margin account (/user_profile/wallet/margin): compact card layout on mobile.
 * Show only Pair (td:nth-child(1)) + Net Assets (td:nth-child(8)) columns.
 * td:nth-child(8) contains the ⋮ button for full-detail popup.
 */


@media (max-width: 1440px) {

  .dashboard_right.funding-account {
    padding: 24px 38px 32px 50px;
  }

  .funding-account__title {
    font-size: 32px;
  }

}

@media (max-width: 1366px) {

  .funding-account__title {
    font-size: 32px;
  }

}


@media (max-width: 1200px) {

  .funding-account__title {
    font-size: 24px;
  }

  .funding-account__pill {
    padding: 6px 16px;
    font-size: 14px;
  }

  .funding-account__totals-num {
    font-size: 24px;
  }

  .margin-pro-page .funding-account__title {
    font-size: 26px;
  }

}

@media (max-width: 991.98px) {
  .funding-account__header {
    align-items: flex-start;
    flex-direction: column;
  }

  .funding-account__toprow {
    align-items: flex-start;
    flex-direction: column;
  }

  /* .funding-account__summary-grid {
    grid-template-columns: 1fr;
  } */

  .dashboard_right.funding-account {
    padding: 15px 20px 24px 20px;
  }

  /* Mobile: turn table into card list */
  .funding-account__tablewrap {
    overflow: visible;
    background: transparent;
  }

  .funding-account__table {
    min-width: 0 !important;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 12px;
    /* vertical gaps between cards */
  }

  .funding-account__table thead {
    display: none;
  }

  .funding-account__header {
    margin: 0px 0 8px;
  }

  /* .funding-account__table tbody,
  .funding-account__table tr,
  .funding-account__table td {
    display: block;
    width: 100%;
  } */

  .funding-account__table tbody tr {
    overflow: hidden;

  }

  .funding-account__table tbody td {
    padding: 12px 2px;
    border-top: none;
  }

  .funding-account__table thead th {
    padding: 12px 2px;
  }

  .funding-account__table tbody td:first-child {
    border-top: 0;
  }

  .funding-account__table tbody td[data-label] {
    align-items: flex-start;
    justify-content: space-between;
    gap: 14px;
  }

  .funding-account__table tbody td[data-label]::before {
    display: none;
  }

  .funding-account__table tbody td[data-label]>* {
    text-align: right;
  }

  /* Prevent long values/actions from being clipped */
  .funding-account__table tbody td[data-label]>* {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .funding-account__table tbody td[data-label="Coin"]>* {
    text-align: left;
  }

  /* Standalone Funding page: same compact table rows as Asset Overview (wallet-page--ao-popup + assetOverview.css) */
  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr {
    border-bottom: 1px solid #f1f5f9;
  }

  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr:last-child {
    border-bottom: none;
  }

  .funding-account__coin>div {
    min-width: 0;
  }

  .funding-account__actions {
    justify-content: flex-end;
    gap: 12px;
  }

  .funding-account__action {
    font-size: 13px;
  }

  .funding-account__search {
    min-width: 0;
    width: 250px;
  }

  /*
   * Futures account (/user_profile/wallet/futures): override card-list table above.
   * Asset Overview–style rows: real table, thead hidden, two columns + ⋮ (see FuturesAccountPage).
   */
  .dashboard_right.funding-account.futures-account-page .funding-account__tablewrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    background: transparent;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures,
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets {
    min-width: 0 !important;
    width: 100%;
    border-collapse: collapse !important;
    border-spacing: 0 !important;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures thead,
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets thead {
    display: none !important;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody,
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody {
    display: table-row-group !important;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody tr,
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody tr {
    display: table-row !important;
    background: transparent !important;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    margin-bottom: 0 !important;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody td,
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody td {
    display: table-cell !important;
    width: auto !important;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody td[data-label]::before,
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody td[data-label]::before {
    display: none !important;
    content: none !important;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures thead th:nth-child(n + 3),
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody td:nth-child(n + 3),
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets thead th:nth-child(n + 3),
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody td:nth-child(n + 3) {
    display: none !important;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions {
    min-width: 1180px;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions thead {
    display: table-header-group !important;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions thead th,
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions tbody td {
    display: table-cell !important;
  }

  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions tbody tr:first-child td,
  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody tr:first-child td {
    border-top: none;
  }


  .funding-account__table--margin tbody,
  .funding-account__table--margin tbody tr,
  .funding-account__table--margin tbody td {
    display: block;
    width: 100%;
  }

  .funding-account__coin-name {
    font-size: 12px;
    font-weight: 400;
  }

  .funding-account__table--margin tbody tr {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #f1f5f921;
    background: transparent !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    margin-bottom: 0 !important;
  }

  .funding-account__table--margin tbody tr:last-child {
    border-bottom: none;
  }

  /* Hide: Coin, Available, Borrowable, Loan Cap, Borrowed, Frozen, Est. Liq, Action */
  .funding-account__table--margin tbody td:nth-child(2),
  .funding-account__table--margin tbody td:nth-child(3),
  .funding-account__table--margin tbody td:nth-child(4),
  .funding-account__table--margin tbody td:nth-child(5),
  .funding-account__table--margin tbody td:nth-child(6),
  .funding-account__table--margin tbody td:nth-child(7),
  .funding-account__table--margin tbody td:nth-child(9),
  .funding-account__table--margin tbody td:nth-child(10) {
    display: none !important;
  }

  /* Pair cell: left-aligned, take available width */
  .funding-account__table--margin tbody td:nth-child(1) {
    width: auto;
    flex: 1 1 auto;
    padding: 0;
    border: none;
    text-align: left;
  }

  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin {
    gap: 10px;
  }

  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin-img {
    width: 36px;
    height: 36px;
  }

  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin span {
    font-size: 15px;
    font-weight: 600;
  }

  .funding-account__table--margin tbody td:nth-child(1) .margin-mmr-badge {
    display: none;
  }

  /* Net Assets cell: right-aligned */
  .funding-account__table--margin tbody td.margin-acct__net-cell {
    width: auto;
    flex: 0 0 auto;
    padding: 0;
    border: none;
    text-align: right;
  }

  .margin-acct__filters {
    flex-wrap: wrap;
    gap: 10px;
  }

  .margin-acct__filters .funding-account__search {
    min-width: 0;
    width: 100%;
    flex: 1 1 100%;
  }

  .margin-acct__filters .funding-account__check {
    font-size: 13px;
    gap: 6px;
    white-space: nowrap;
  }

  .margin-pro-page .funding-account__header {
    margin: 0px 0 24px;
  }

  .margin-pro-page .funding-account__title {
    font-size: 24px;
  }


}

@media (max-width: 767px) {

  .funding-account__title {
    font-size: 22px;
  }

  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin span {
    font-size: 13px;
  }

  div#marginBorrowRepayModal .modal-content {
    min-height: 50vh;
    max-height: 70vh;
  }

  .dashboard_right.funding-account {
    width: 100%;
  }

  .funding-account__action {
    font-size: 12px;
  }

  .dashboard_right.funding-account.margin-pro-page {
    padding-top: 16px !important;
  }

  .margin-pro-page .funding-account__title {
    font-size: 20px;
  }

  .margin-pro-page .funding-account__summary-num {
    font-size: 24px;
  }

  .margin-pro-page .marginwallet_card {
    flex-direction: column;
  }

  .margin-pro-page .funding-account__summary-main {
    padding-right: 0px;
    width: 100%;
  }

  .margin-pro-page .funding-account__summary-stat {
    padding-left: 0px;
    padding-right: 20px;
    /* border-right: 1px solid #EAECEF; */
    border-left: none;
  }

  .margin-pro-page .funding-account__summary-grid {
    padding-left: 0px;
    width: 100%;
  }

  .so-filtersModal--filters .modal-footer {
    border: none;
    padding: 0px 20px 10px;
  }

  .so-filtersModal--filters .modal-footer button {
    font-size: 14px;
  }

  .funding-account__actions {
    gap: 6px;
  }

  .funding-account__summary-num {
    font-size: 22px;
  }

  .funding-account__pill {
    padding: 7px 11px;
  }

  .margin-pro-page .funding-account__filters {
    padding: 16px 0px;
  }

  .margin-pro-page .funding-account__table td:first-child {
    padding-left: 0px;
  }

  .modal.agce-ao-sheet-modal .agce-ao-sheet__hero-num {
    font-size: 18px;
  }

  .margin-modal-actions .btn {
    padding: 9px !important;
    font-size: 13px !important;
  }

  .agce-ao-sheet-dialog .agce-ao-sheet__body {
    padding-bottom: 0px !important;
  }

  .margin_pnl_bl {
    flex-direction: column;
  }

  .funding_acount_block_margin {
    padding: 20px;
    margin: 0 0 0px 0;
  }


  .margin-modal-container .margin-modal-tab-wrapper {
    font-size: 15px;
  }

  .cmp-mobile-row-divider {
    border-top: none;
    padding-top: 14px;
    width: 100%;
    border: 1px solid #eaecef2b;
    border-radius: 12px;
    padding: 20px;
    margin: 0 0 0px 0 !important;
    box-shadow: none;
  }

  body.light_theme .cmp-mobile-row-divider {
    border: 1px solid #EAECEF;
  }

  .cmp-stat-val {
    font-size: 15px;
  }

  .d-md-none.mt-3.cmp-mobile-row-divider.buttons_row {
    margin-top: 24px !important;
  }

  .funding-account__summary-stat-k {
    font-size: 12px;
  }

  .agce-ao-sheet__table-actions .btn-link,
  .agce-ao-sheet__table-actions .funding-account__action,
  .agce-ao-sheet__table-actions .funding-account__action--btn {
    min-height: 36px;
    padding: 7px 10px;
    font-size: 13px;
  }

  .margin-pro-page .funding-account__summary-top {
    margin-bottom: 5px;
  }

  .margin-pro-page .funding-account__summary-sub {
    margin-bottom: 15px;
  }

  .margin-pro-page .funding-account__summarycard {
    padding: 15px;
    margin: 0 0 15px 0;
  }

  .margin-pro-page .funding-account__pill {
    padding: 8px 20px;
    font-size: 13px;
  }

  .funding-account__summary-pnl {
    font-size: 13px;
  }

  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin-img {
    width: 24px;
    height: 24px;
  }

  .cmp-mobile-filter-body .funding-account__search.cmp-w-100 {
    width: 100%;
  }

}


@media (max-width: 580px) {

  .funding-account__search {
    width: 180px;
  }

  .margin-acct__filters .funding-account__check {
    font-size: 12px;
  }

  .funding-account__check {
    font-size: 12px;
  }

  .margin-modal-legend {
    font-size: 13px !important;
  }

  .cmp-checkbox-label {
    font-size: 13px;
  }

  .so-filtersModal--filters .modal-body {
    padding: 5px 20px 10px !important;
  }

  .funding-account__title {
    font-size: 20px;
  }

  .funding-account__summary-num {
    font-size: 18px;
  }

  .modal.agce-ao-sheet-modal .agce-ao-sheet__kv {
    font-size: 12px;
    padding: 5px 0;
  }

  .funding-account__subnum {
    font-size: 12px;
  }

  .funding-account__pill {
    font-size: 12px;
  }

}

/* Options wallet — summary card action buttons (override margin-pro-page pill defaults) */
.options-account-page.margin-pro-page .funding-account__summarycard .options-account__summary-actions {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  gap: 10px;
  align-self: center;
  margin-left: auto;
  min-width: 168px;
}

.options-account-page.margin-pro-page .funding-account__summarycard .options-account__summary-actions .funding-account__pill {
  width: 100%;
  margin: 0;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  background-image: none;
}

.options-account-page.margin-pro-page .funding-account__summarycard .options-account__summary-actions .funding-account__pill::before {
  content: none;
  display: none;
}

.options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-transfer {
  background-color: #292b30;
  color: #fff;
}

body.light_theme .options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-transfer {
  color: #000;
  background-color: #ededed;
}

.options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-history {
  background-color: #ededed14;
  color: #ffffff;
}


body.light_theme .options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-history {
  background-color: #EDEDED;
  color: #1E2329;
}

.options-account-page.margin-pro-page .funding-account__totals-label::after {
  content: none;
  display: none;
}

.options-account-page .funding-account__action,
.options-account-page .funding-account__action--btn {
  color: #d1aa67;
}

body.dark .options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-transfer {
  background-color: #FCD535;
  color: #181A20;
}

body.dark .options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-history {
  background-color: #2B3139;
  color: #EAECEF;
}

/* Mobile Card View for Options Account Page */
@media (max-width: 991.98px) {
  .dashboard_right.funding-account.options-account-page .funding-account__tablewrap {
    overflow-x: hidden;
    background: transparent;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table thead {
    display: none !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table,
  .dashboard_right.funding-account.options-account-page .funding-account__table tbody,
  .dashboard_right.funding-account.options-account-page .funding-account__table tr,
  .dashboard_right.funding-account.options-account-page .funding-account__table td {
    display: block !important;
    width: 100% !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table tr {
    margin-bottom: 16px !important;
    border: 1px solid #f3f4f61f !important;
    border-radius: 12px !important;
    padding: 12px 16px !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
  }

  body.light_theme .dashboard_right.funding-account.options-account-page .funding-account__table tr {
    border-color: #F3F4F6 !important;
    background: #ffffff !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table tr.no-data-row,
  .dashboard_right.funding-account.options-account-page .funding-account__table tr.no-data-row td {
    display: block !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table tr.no-data-row td::before {
    display: none !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table td {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding: 10px 0 !important;
    border-top: none !important;
    text-align: right !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table td::before {
    content: attr(data-label);
    font-size: 13px;
    color: #8E939C;
    display: block !important;
    text-align: left;
    margin-right: 16px;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table td:first-child {
    border-bottom: 1px solid #f3f4f61f !important;
    padding-bottom: 12px !important;
    margin-bottom: 4px !important;
    justify-content: flex-start !important;
  }

  body.light_theme .dashboard_right.funding-account.options-account-page .funding-account__table td:first-child {
    border-bottom-color: #F3F4F6 !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table td:first-child::before {
    display: none !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table td>* {
    text-align: right;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label="Action"] {
    margin-top: 8px !important;
    padding-top: 12px !important;
    border-top: 1px dashed #f3f4f61f !important;
    justify-content: center !important;
  }

  body.light_theme .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label="Action"] {
    border-top-color: #F3F4F6 !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label="Action"]::before {
    display: none !important;
  }

  .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label="Action"] .funding-account__action {
    background: #d1aa67;
    color: #fff;
    padding: 6px 24px;
    border-radius: 6px;
    font-weight: 500;
    text-decoration: none;
    display: inline-block;
  }

  body.light_theme .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label="Action"] .funding-account__action {
    background: #d1aa67;
    color: #fff;
  }
}

@media (max-width: 767px) {

  body.light_theme .margin-pro-page .funding-account__summary-stat {
    border-left: none;
  }

  .funding-account__filters.rightsearch {
    justify-content: space-between;
  }

  .margin-pro-page .funding-account__check {
    margin-left: 12px;
  }

  .funding-account__table tbody td {
    padding: 8px 2px;
  }

  .options-account-page.margin-pro-page .funding-account__header-actions.options-account__summary-actions {
    min-width: 100%;
    display: flex;
    flex-direction: row;
  }

  .options-account-page.margin-pro-page .funding-account__header-actions.options-account__summary-actions .funding-account__pill {
    width: auto;
  }

  .margin-pro-page .funding-account__summary-stat {
    border-left: none;
  }

  .options-account-page.margin-pro-page .funding-account__summarycard .options-account__summary-actions .funding-account__pill {
    padding: 7px 20px;
    font-size: 12px;
  }


}

span.badge.cmp-risk-badge-mobile.bg-success {
  color: #fff;
  z-index: 0;
  background: #3a3a3a !important;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/FundingAccountPage/fundingAccount.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mDAAmD;EACnD,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,eAAe;EACf,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gEAAgE;EAChE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;;AAGA;EACE,cAAc;AAChB;;;AAGA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;;AAE7B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,4DAA4D;EAC5D,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAO;EACP,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;;;;;AAMA,oFAAoF;AACpF;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uFAAuF;AACvF;;EAEE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,4BAA4B;AAC9B;;AAEA;;EAEE,YAAY;EACZ,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,8FAA8F;AAC9F;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;GAOG;;AAEH;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yDAAkN;EAClN,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,MAAM;AACR;;AAEA;EACE,SAAO;EACP,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;;GAMG;;AAEH;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;;AAGA,wBAAwB;AACxB;;;;EAIE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA,iEAAiE;AACjE;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;;;;EAIE;;;AAGF;;EAEE;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;AAEF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;KAEG;;EAEH;IACE,4BAA4B;EAC9B;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;;;;KAKG;;EAEH;IACE,gBAAgB;;EAElB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA,mDAAmD;EACnD;IACE,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,mHAAmH;EACnH;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;;;IAGE;EACF;IACE,gBAAgB;IAChB,iCAAiC;IACjC,uBAAuB;EACzB;;EAEA;;IAEE,uBAAuB;IACvB,WAAW;IACX,oCAAoC;IACpC,4BAA4B;EAC9B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,mCAAmC;EACrC;;EAEA;;IAEE,6BAA6B;IAC7B,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;;IAEE,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;;IAEE,wBAAwB;IACxB,wBAAwB;EAC1B;;EAEA;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gBAAgB;EAClB;;;EAGA;;;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kCAAkC;IAClC,kCAAkC;IAClC,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA,oFAAoF;EACpF;;;;;;;;IAQE,wBAAwB;EAC1B;;EAEA,kDAAkD;EAClD;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,mCAAmC;EACnC;IACE,WAAW;IACX,cAAc;IACd,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;;AAGF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;AAEF;;;AAGA;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA,0FAA0F;AAC1F;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;;AAGA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;;;IAIE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,sCAAsC;IACtC,8BAA8B;IAC9B,6BAA6B;IAC7B,mDAAmD;EACrD;;EAEA;IACE,gCAAgC;IAChC,8BAA8B;IAC9B,oDAAoD;EACtD;;EAEA;;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,yCAAyC;IACzC,8BAA8B;IAC9B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,6CAA6C;IAC7C,+BAA+B;IAC/B,6BAA6B;IAC7B,sCAAsC;EACxC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,2CAA2C;IAC3C,kCAAkC;EACpC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;;AAGF;;AAEA;EACE,WAAW;EACX,UAAU;EACV,8BAA8B;AAChC","sourcesContent":[".funding-account {\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.funding-account__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  border-bottom: 1px solid #f4f4f430;\n  margin: 6px 0 8px;\n  padding-bottom: 10px;\n}\n\nbody.light_theme .funding-account__header {\n  border-bottom: 1px solid #f4f4f4;\n}\n\n.funding-account__title {\n  margin: 0;\n  font-size: 32px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.funding-account__header-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.marginwallet_card {\n  gap: 40px;\n  align-items: start;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.funding-account__totals-label.h4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #2e2e2e;\n}\n\n.marginwallet_card .funding-account__summary-grid {\n  gap: 60px;\n}\n\n.funding-account__filters.funding-account__filters--tight.margin-acct__filters.rightsearch {\n  justify-content: end;\n}\n\n.funding-account__filters.rightsearch {\n  justify-content: flex-end;\n}\n\n.funding-account__pill {\n  border: 1px solid #ededed08;\n  background: #ffffff2b;\n  color: #fdfdfd;\n  padding: 8px 22px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.funding-account__pill:hover {\n  opacity: 0.8;\n}\n\nbody.light_theme .funding-account__pill {\n  border: 1px solid #ededed;\n  background: #ededed;\n  color: #000;\n}\n\n.funding-account__pill--primary {\n  border: 1px solid #ededed08;\n  background: #ffffff2b;\n  color: #fdfdfd;\n  padding: 8px 22px;\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\nbody.light_theme .funding-account__pill--primary {\n  border: 1px solid #ededed;\n  background: #ededed;\n  color: #000;\n}\n\n.funding-account__toprow {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 6px 0 10px;\n}\n\n.funding-account__totals-label {\n  font-size: 15px;\n  font-weight: 400;\n  color: #858f9c;\n}\n\n.funding-account__totals-main {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.funding-account__totals-num {\n  font-size: 30px;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n}\n\n.funding-account__totals-sub {\n  font-size: 14px;\n  font-weight: 400;\n  color: #94a3b8;\n}\n\n.funding-account__spot-pnl {\n  min-width: 220px;\n  max-width: 320px;\n}\n\n.funding-account__spot-pnl .spot-pnl-analysis-link {\n  font-size: 12px;\n  font-weight: 500;\n  color: #c99400;\n  text-decoration: none;\n}\n\n.funding-account__spot-pnl .spot-pnl-analysis-link:hover {\n  text-decoration: underline;\n}\n\n.funding-account__spot-pnl-sk__title {\n  width: 36px;\n  height: 14px;\n  border-radius: 4px;\n}\n\n.funding-account__spot-pnl-sk__period {\n  width: 32px;\n  height: 22px;\n  border-radius: 4px;\n}\n\n.funding-account__spot-pnl-sk__cell {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.funding-account__spot-pnl-sk__label {\n  display: block;\n  width: 72px;\n  height: 11px;\n  border-radius: 4px;\n}\n\n.funding-account__spot-pnl-sk__val {\n  display: block;\n  width: 96px;\n  height: 16px;\n  border-radius: 4px;\n}\n\n@media (max-width: 991.98px) {\n  .funding-account__spot-pnl {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n.funding-account__details-btn {\n  border: 1px solid #F6F6F6;\n  background: #F6F6F6;\n  color: #475569;\n  border-radius: 999px;\n  padding: 8px 14px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.funding-account__filters {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin: 10px 0 12px;\n}\n\n.funding-account__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #e5e7eb3d;\n  height: 38px;\n  border-radius: 7px;\n  padding: 6px 12px;\n  min-width: 440px;\n  background: none;\n}\n\nbody.light_theme .funding-account__search {\n  border: 1px solid #E5E7EB;\n}\n\n.funding-account__search i {\n  color: #94a3b8;\n}\n\n.funding-account__search input {\n  border: 0;\n  outline: none;\n  background: none;\n  width: 100%;\n  color: #fff;\n  font-size: 13px;\n}\n\nbody.light_theme .funding-account__search input {\n  color: #000;\n}\n\n.funding-account__search.slide-search-box {\n  min-width: unset;\n  width: 38px;\n  overflow: hidden;\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  border: none !important;\n  white-space: nowrap;\n}\n\n.funding-account__search.slide-search-box.search_active {\n  width: 250px;\n}\n\n.funding-account__search.slide-search-box input {\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n}\n\n.funding-account__search.slide-search-box.search_active input {\n  opacity: 1;\n  pointer-events: auto;\n  transition-delay: 0.1s;\n}\n\n.funding-account__check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #c4c4c4;\n}\n\nbody.light_theme .funding-account__check {\n  color: #4A5565;\n}\n\n.funding-account__check input {\n  width: 14px;\n  height: 14px;\n}\n\n.funding-account__hintbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid #eef2f70d;\n  background: #f6f6f60f;\n  color: #c9c9c9;\n  border-radius: 12px;\n  padding: 13px 12px;\n  font-size: 12px;\n  font-weight: 400;\n}\n\nbody.light_theme .funding-account__hintbar {\n  border: 1px solid #eef2f7;\n  background: #F6F6F6;\n  color: #64748b;\n}\n\n.funding-account__tablewrap {\n  margin-top: 12px;\n}\n\n.dashboard_right.funding-account {\n  padding: 24px 150px 32px 70px;\n}\n\n.funding-account__tablewrap {\n  overflow-x: auto;\n}\n\n.funding-account__table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 980px;\n}\n\n.funding-account__table--margin {\n  min-width: 1180px;\n}\n\n.funding-account__pair {\n  font-size: 12px;\n  font-weight: 500;\n  color: #0f172a;\n  white-space: nowrap;\n}\n\n.funding-account__summarycard {\n  border: 1px solid #f3f4f61f;\n  border-radius: 12px;\n  padding: 16px 18px;\n  margin: 5px 0 18px;\n}\n\nbody.light_theme .funding-account__summarycard {\n  border: 1px solid #F3F4F6;\n}\n\n.funding-account__summary-top {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 10px;\n}\n\n.funding-account__summary-icons {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: #94a3b8;\n  font-size: 16px;\n}\n\n.funding-account__summary-main {\n  margin-top: 10px;\n}\n\n.funding-account__summary-amount {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.funding-account__summary-num {\n  font-size: 30px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #fff;\n  line-height: 1.1;\n}\n\nbody.light_theme .funding-account__summary-num {\n  color: #0f172a;\n}\n\n.funding-account__summary-unit {\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n}\n\n.funding-account__summary-sub {\n  margin-top: 2px;\n  font-size: 15px;\n  color: #94a3b8;\n  font-weight: 400;\n}\n\n.funding-account__summary-pnl {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 15px;\n  color: #94a3b8;\n}\n\n.funding-account__summary-pnl strong {\n  color: #0f172a;\n  font-weight: 500;\n}\n\n.funding-account__summary-grid {\n  margin-top: 12px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.funding-account__summary-stat-k {\n  font-size: 14px;\n  color: #dbdbdb;\n  font-weight: 400;\n}\n\nbody.light_theme .funding-account__summary-stat-k {\n  color: #94a3b8;\n}\n\n.funding-account__summary-stat-v {\n  margin-top: 4px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.funding-account__summary-stat--right {\n  text-align: right;\n}\n\nbody.light_theme .funding-account__summary-stat-v {\n  color: #0f172a;\n}\n\n.funding-account__filters--tight {\n  margin-top: 0;\n}\n\n.funding-account__filters--spread {\n  justify-content: space-between;\n}\n\n.funding-account__tabs {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin: 8px 0 16px;\n}\n\n.funding-account__tab {\n  border: 0;\n  background: transparent;\n  padding: 8px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #94a3b8;\n  cursor: pointer;\n  position: relative;\n}\n\n.funding-account__tab.is-active {\n  color: #fff;\n}\n\nbody.light_theme .funding-account__tab.is-active {\n  color: #0f172a;\n}\n\n.funding-account__tab.is-active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -2px;\n  width: 35%;\n  margin: 0 auto;\n  height: 2px;\n  background: #d1aa67;\n  border-radius: 999px;\n}\n\n.funding-account__table--futures {\n  min-width: 1180px;\n}\n\n.funding-account__table--futures-assets {\n  min-width: 980px;\n}\n\n.funding-account__table--futures-positions {\n  min-width: 1180px;\n}\n\n.agce-ft-acct-pos-margin {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.agce-ft-acct-pos-margin__text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.25;\n}\n\n.agce-ft-acct-pos-margin__value {\n  font-weight: 600;\n}\n\n.agce-ft-acct-pos-margin__mode {\n  font-size: 11px;\n  color: #848e9c;\n}\n\n.agce-ft-acct-pos-margin__edit {\n  border: none;\n  background: transparent;\n  color: #848e9c;\n  padding: 0;\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n}\n\n.agce-ft-acct-pos-margin__edit:hover {\n  color: #d1aa67;\n}\n\nbody.light_theme .agce-ft-acct-pos-margin__mode,\nbody.light_theme .agce-ft-acct-pos-margin__edit {\n  color: #9a9da3;\n}\n\nbody.light_theme .agce-ft-acct-pos-margin__edit:hover {\n  color: #d1aa67;\n}\n\n.funding-account__table--futures-positions tbody td {\n  vertical-align: top;\n}\n\n.funding-account__table--futures-positions .small.text-muted {\n  font-size: 12px;\n  color: #94a3b8;\n  margin-top: 2px;\n}\n\n.funding-account__table--futures-positions .funding-account__coin-sym {\n  font-weight: 600;\n}\n\n.funding-account__table thead th {\n  padding: 12px 14px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #8E939C;\n  text-align: left;\n  border-bottom: 1px solid #f3f4f61f;\n  white-space: nowrap;\n}\n\nbody.light_theme .funding-account__table thead th {\n  border-bottom: 1px solid #F3F4F6;\n}\n\n.funding-account__table thead th.ta-r {\n  text-align: right;\n}\n\n.funding-account__table tbody td {\n  padding: 12px 14px;\n  border-top: 1px solid #f1f5f91f;\n  vertical-align: middle;\n  font-size: 13px;\n}\n\nbody.light_theme .funding-account__table tbody td {\n  border-top: 1px solid #f1f5f9;\n}\n\n.ta-r {\n  text-align: right;\n}\n\n.funding-account__coin {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.funding-account__coin-dot {\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  background: radial-gradient(circle at 30% 30%, #4b5563, #111827);\n  display: inline-block;\n}\n\n.agce-ao-sheet__brand .funding-account__coin-dot.agce-ao-sheet__coin-dot {\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n}\n\n.funding-account__coin-img {\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.funding-account__coin-sym {\n  font-size: 14px;\n  font-weight: 500;\n}\n\nlabel.funding-account__check.smallkcs {\n  color: #AC8A50;\n}\n\nbutton.btn.margin-modal-btn-cancel {\n  width: 50%;\n}\n\nbutton.btn.margin-modal-btn-confirm {\n  color: #000000;\n  background: #d1aa67;\n}\n\n.funding-account__coin-name {\n  font-size: 14px;\n  color: #f0f0f0;\n  font-weight: 500;\n}\n\nbody.light_theme .funding-account__coin-name {\n  color: #0f172a;\n}\n\n.funding-account__num {\n  font-size: 14px;\n  font-weight: 500;\n  color: #efefef;\n}\n\nbody.light_theme .funding-account__num {\n  color: #000;\n}\n\n.funding-account__subnum {\n  font-size: 14px;\n  color: #f3f3f3;\n  font-weight: 400;\n  margin-top: 2px;\n}\n\nbody.light_theme .funding-account__subnum {\n  color: #000;\n}\n\n.funding-account__actions {\n  display: inline-flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.funding-account__action {\n  font-size: 12px;\n  /* font-weight: 600; */\n  color: #f1f1f1;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\nbody.light_theme .funding-account__action {\n  color: #262933;\n}\n\n.funding-account__action--btn {\n  border: 0;\n  background: transparent;\n  padding: 0;\n}\n\n.funding-account__action:hover {\n  text-decoration: underline;\n  color: #e9e9e9;\n}\n\n\nbody.light_theme .funding-account__action:hover {\n  color: #262933;\n}\n\n\n/* Margin Borrow/Repay Modal Redesign */\n.margin-modal-tabs {\n  display: flex;\n  gap: 32px;\n  width: 100%;\n}\n\n.margin-modal-tab-wrapper {\n  position: relative;\n  font-size: 16px;\n  font-weight: 600;\n  color: #707A8A;\n  cursor: pointer;\n  padding-bottom: 8px;\n  transition: color 0.2s;\n}\n\n.margin-modal-tab-wrapper.margin-modal-tab--active {\n  color: #1E2329;\n}\n\n/* Dark mode adjustment */\n.dark-theme .margin-modal-tab-wrapper.margin-modal-tab--active {\n  color: #EAECEF;\n}\n\n.margin-modal-tab-indicator {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 24px;\n  height: 4px;\n  background-color: #FCD535;\n  border-radius: 2px;\n}\n\n.margin-type-toggle-container {\n  display: flex;\n  margin-bottom: 24px;\n}\n\n.margin-type-toggle {\n  display: inline-flex;\n  background-color: #F5F5F5;\n  border-radius: 8px;\n  padding: 4px;\n}\n\n.dark-theme .margin-type-toggle {\n  background-color: #2B3139;\n}\n\n.margin-type-toggle-btn {\n  padding: 6px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #707A8A;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.margin-type-toggle-btn.active {\n  background-color: #FFFFFF;\n  color: #1E2329;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.dark-theme .margin-type-toggle-btn.active {\n  background-color: #3B444F;\n  color: #EAECEF;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.margin-modal-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 0;\n  text-align: center;\n}\n\n.margin-modal-empty-icon {\n  margin-bottom: 24px;\n}\n\n.margin-modal-empty-text {\n  font-size: 14px;\n  color: #707A8A;\n  max-width: 300px;\n  margin-bottom: 24px;\n  line-height: 1.5;\n}\n\n.margin-modal-transfer-btn {\n  background-color: #2c2c2c !important;\n  color: #ffffff !important;\n  font-weight: 600 !important;\n  padding: 8px 48px !important;\n  border-radius: 8px !important;\n  border: none !important;\n  font-size: 15px !important;\n  min-width: 240px;\n}\n\n.margin-modal-transfer-btn:hover {\n  opacity: 0.9;\n}\n\n/* Override existing cancel/confirm for the new full width style */\n.margin-modal-actions {\n  display: flex;\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.margin-modal-actions .btn {\n  border-radius: 8px !important;\n  padding: 12px !important;\n  font-weight: 600 !important;\n  font-size: 16px !important;\n}\n\n/* Modern Form Overrides */\n.modern-margin-form .margin-coin-radios {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n  margin-bottom: 24px;\n}\n\n.modern-margin-form .margin-coin-pill {\n  flex: 1;\n  text-align: center;\n  padding: 10px;\n  border-radius: 8px;\n  background-color: #F5F5F5;\n  color: #1E2329;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid transparent;\n}\n\n.dark-theme .modern-margin-form .margin-coin-pill {\n  background-color: #2B3139;\n  color: #EAECEF;\n}\n\n.modern-margin-form .margin-coin-pill.active {\n  background-color: #FFFFFF;\n}\n\n.dark-theme .modern-margin-form .margin-coin-pill.active {\n  background-color: #1E2329;\n}\n\n.modern-margin-form .price_max_total {\n  /* background-color: #F5F5F5 !important; */\n  border: 1px solid transparent !important;\n  border-radius: 8px !important;\n  padding: 4px 12px !important;\n}\n\n.dark-theme .modern-margin-form .price_max_total {\n  background-color: #2B3139 !important;\n}\n\n.modern-margin-form .price_max_total input {\n  background-color: transparent !important;\n}\n\n.modern-margin-form .margin-modal-actions .btn-cancel-modern {\n  background-color: #EAECEF !important;\n  color: #1E2329 !important;\n}\n\n.modern-margin-form .margin-modal-actions .btn-confirm-modern {\n  background-color: #2c2c2c !important;\n  color: #ffffff !important;\n}\n\n.modern-margin-form .margin-modal-actions .btn-confirm-modern:hover {\n  opacity: 0.9;\n}\n\n.dark-theme .modern-margin-form .margin-modal-actions .btn-cancel-modern {\n  background-color: #2B3139 !important;\n  color: #EAECEF !important;\n}\n\n/* Margin Borrow Repay Modal Styles */\n.margin-modal-container .modal-content {\n  border-radius: 24px;\n}\n\n.margin-modal-container .margin-modal-tabs {\n  display: flex;\n  gap: 24px;\n  /* margin-bottom: 20px; */\n}\n\n.margin-modal-legend {\n  font-size: 15px !important;\n}\n\n.margin-modal-container .margin-modal-tab-wrapper {\n  position: relative;\n  font-size: 18px;\n  font-weight: 600;\n  color: #707A8A;\n  padding-bottom: 12px;\n  cursor: pointer;\n}\n\n.margin-modal-container .margin-modal-tab-wrapper.active {\n  font-weight: 700;\n  color: #ffffff;\n}\n\nbody.light_theme .margin-modal-container .margin-modal-tab-wrapper.active {\n  color: #1E2329;\n}\n\n.margin-modal-container .margin-modal-tab-indicator {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 42px;\n  height: 3px;\n  background-color: #d1aa67;\n  border-radius: 2px;\n}\n\n.margin-modal-container .margin-modal-close {\n  align-self: flex-start;\n}\n\n.margin-modal-container .margin-type-toggle-container {\n  display: flex;\n  width: 100%;\n  margin-bottom: 24px;\n  border-radius: 8px;\n  border: 1px solid #EAECEF;\n  padding: 2px;\n}\n\n.margin-modal-container .margin-type-toggle {\n  flex: 1 1;\n  text-align: center;\n  padding: 8px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  color: #8c8c8c;\n  background-color: transparent;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.margin-modal-container .margin-type-toggle.active {\n  font-weight: 600;\n  color: #1E2329;\n  background-color: #F5F5F5;\n}\n\n.margin-modal-container .repay-label {\n  font-size: 13px;\n  color: #707A8A;\n  margin-bottom: 8px;\n  display: block;\n  font-weight: 500;\n}\n\n.margin-modal-container .repay-input-container {\n  position: relative;\n}\n\n.margin-modal-container .repay-input-wrapper {\n  border: 1px solid #eaecef17;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  background-color: #ffffff1a;\n\n}\n\nbody.light_theme .margin-modal-container .repay-input-wrapper {\n  border: 1px solid #EAECEF;\n  background-color: #FFFFFF;\n}\n\n.margin-modal-container .coin-dropdown-trigger {\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  border-right: 1px solid #eaecef17;\n}\n\nbody.light_theme .margin-modal-container .coin-dropdown-trigger {\n  border-right: 1px solid #EAECEF;\n}\n\n.margin-modal-container .coin-icon-small {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #F0F0F0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.margin-modal-container .coin-icon-text {\n  font-size: 9px;\n  font-weight: bold;\n  color: #707A8A;\n}\n\n.margin-modal-container .coin-symbol {\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.funding-account__table tr:hover {\n  box-shadow: 0px 0px 20px #f3ba2b14;\n  background-color: rgb(54 54 54 / 11%);\n}\n\n.funding-account__table tr {\n  transition: background-color 0.2s ease, box-shadow 0.2s ease;\n  border-left: none !important;\n}\n\nbody.light_theme .margin-modal-container .coin-symbol {\n  color: #1E2329;\n}\n\n.margin-modal-container .coin-dropdown-icon {\n  color: #e6e6e6;\n  font-size: 14px;\n}\n\nbody.light_theme .margin-modal-container .coin-dropdown-icon {\n  color: #707A8A;\n}\n\n.margin-modal-container .repay-nothing-text {\n  flex: 1;\n  padding: 12px 16px;\n  color: #707A8A;\n  font-size: 14px;\n}\n\n.margin-modal-container .repay-amount-input {\n  border: none;\n  outline: none;\n  background: transparent;\n  /* text-align: right; */\n  flex: 1 1;\n  width: 100%;\n  padding: 12px 16px;\n  color: #1E2329;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.dark-theme .margin-modal-container .repay-amount-input {\n  color: #EAECEF;\n}\n\n.margin-modal-container .search-input-wrapper {\n  position: relative;\n}\n\n.margin-modal-container .isolated-pair-popover {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: #25282e;\n  border: 1px solid #eaecef17;\n  border-radius: 8px;\n  margin-top: 4px;\n  z-index: 10;\n  max-height: 300px;\n  display: flex;\n  flex-direction: column;\n}\n\nbody.light_theme .margin-modal-container .isolated-pair-popover {\n  background-color: #FFFFFF;\n  border: 1px solid #EAECEF;\n}\n\n.margin-modal-container .search-header {\n  border-bottom: 1px solid #eaecef17;\n}\n\nbody.light_theme .margin-modal-container .search-header {\n  border-bottom: 1px solid #EAECEF;\n}\n\n.margin-modal-container .search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #707A8A;\n}\n\n.margin-modal-container .search-input {\n  width: 100%;\n  padding: 8px 12px 8px 36px;\n  border: 1px solid #eaecef17;\n  background-color: #181a20;\n  color: #ffffff;\n  border-radius: 8px;\n  outline: none;\n  font-size: 14px;\n}\n\nbody.light_theme .margin-modal-container .search-input {\n  border: 1px solid #EAECEF;\n  background-color: #FFFFFF;\n  color: #1E2329;\n}\n\n.margin-modal-container .popover-list {\n  overflow-y: auto;\n  flex: 1;\n  padding: 8px 0;\n}\n\n.margin-modal-container .isolated-pair-option {\n  padding: 10px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  background-color: transparent;\n}\n\n.margin-modal-container .isolated-pair-option:hover {\n  background-color: #ffffff14;\n}\n\n.margin-modal-container .isolated-pair-option.active {\n  background-color: #ffffff1f;\n}\n\nbody.light_theme .margin-modal-container .isolated-pair-option:hover {\n  background-color: #F5F5F5;\n}\n\nbody.light_theme .margin-modal-container .isolated-pair-option.active {\n  background-color: #F5F5F5;\n}\n\n.margin-modal-container .coin-info-group {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.margin-modal-container .coin-icon-medium {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #F0F0F0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.margin-modal-container .coin-icon-text-medium {\n  font-size: 10px;\n  font-weight: bold;\n  color: #707A8A;\n}\n\n.margin-modal-container .coin-text-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.margin-modal-container .coin-name {\n  font-weight: 500;\n  color: #ffffff;\n  font-size: 14px;\n  line-height: 1.2;\n}\n\nbody.light_theme .margin-modal-container .coin-name {\n  color: #1E2329;\n}\n\n.margin-modal-container .coin-fullname {\n  color: #707A8A;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.margin-modal-container .coin-balance-group {\n  text-align: right;\n  font-size: 13px;\n  color: #707A8A;\n}\n\n.margin-modal-container .coin-balance-val {\n  color: #ffffff;\n}\n\nbody.light_theme .margin-modal-container .coin-balance-val {\n  color: #1E2329;\n}\n\n.margin-modal-container .margin-modal-empty-note {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  background-color: #2b313d;\n  padding: 12px 16px;\n  border-radius: 8px;\n  color: #f1f1f1;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\nbody.light_theme .margin-modal-container .margin-modal-empty-note {\n  background-color: #F5F5F5;\n  color: #1E2329;\n}\n\n.margin-modal-container .empty-note-icon {\n  font-size: 16px;\n  margin-top: 1px;\n}\n\n.margin-modal-container .isolated-pair-selector-wrap {\n  position: relative;\n}\n\n.margin-modal-container .isolated-pair-input {\n  /* border: 1px solid #eaecef17; */\n  border-radius: 8px;\n  padding: 12px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  background-color: #2b313d;\n}\n\nbody.light_theme .margin-modal-container .isolated-pair-input {\n  border: 1px solid #EAECEF;\n  background-color: #FFFFFF;\n}\n\n.margin-modal-container .margin-coin-radios {\n  display: flex;\n  gap: 12px;\n}\n\n.margin-modal-container .borrow-input-wrapper {\n  border: 1px solid #EAECEF;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  background-color: #FFFFFF;\n  padding: 12px 16px;\n  margin-bottom: 8px;\n}\n\n.margin-modal-container .borrow-input {\n  border: none;\n  outline: none;\n  flex: 1;\n  font-size: 14px;\n  color: #1E2329;\n  background-color: transparent;\n}\n\n.margin-modal-container .max-borrow-info {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #707A8A;\n  margin-bottom: 16px;\n}\n\n.margin-modal-container .max-borrow-btn {\n  color: #FCD535;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.margin-modal-container .margin-modal-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.margin-modal-container .btn-cancel-modern {\n  flex: 1;\n  padding: 12px;\n  border: 1px solid #EAECEF;\n  border-radius: 8px;\n  background-color: #FFFFFF;\n  font-weight: 600;\n}\n\n.margin-modal-container .btn-confirm-modern {\n  flex: 1;\n  padding: 12px;\n  border: none;\n  border-radius: 8px;\n  background-color: #FCD535;\n  color: #1E2329;\n  font-weight: 600;\n}\n\n.margin-modal-container .isolated-coin-card {\n  flex: 1 1;\n  padding: 16px;\n  /* border: 1px solid #eaecef1f; */\n  border-radius: 4px;\n  text-align: left;\n  cursor: pointer;\n  background-color: #2b313d;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.margin-modal-container .isolated-coin-card span {\n  color: #fff !important;\n}\n\nbody.light_theme .margin-modal-container .isolated-coin-card span {\n  color: #070707 !important;\n}\n\nbody.light_theme .margin-modal-container .isolated-coin-card {\n  border: 1px solid #EAECEF;\n  background-color: #ffffff70;\n}\n\n.margin-modal-container .isolated-coin-card.active {\n  border: 1px solid #d1aa67;\n}\n\n.margin-modal-container .coin-card-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.margin-modal-container .coin-card-body {\n  display: flex;\n  flex-direction: column;\n  margin-left: 28px;\n}\n\n.margin-modal-container .margin-info-rows {\n  font-size: 13px;\n  color: #707A8A;\n}\n\n.margin-modal-container .margin-info-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.margin-modal-container .margin-info-val {\n  color: #1E2329;\n  font-weight: 500;\n}\n\n.margin-modal-container .margin-info-val.red {\n  color: #e45561;\n}\n\n.margin-modal-container .margin-info-total {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 8px;\n  border-top: 1px solid #EAECEF;\n  margin-bottom: 8px;\n}\n\n.margin-modal-container .margin-info-total-val {\n  color: #1E2329;\n  font-weight: 600;\n}\n\n.margin-modal-container .repay-full-checkbox {\n  width: 14px;\n  height: 14px;\n  accent-color: #FCD535;\n}\n\n.margin-modal-container .repay-full-label {\n  cursor: pointer;\n  font-size: 13px;\n  color: #1E2329;\n}\n\n\n\n\n\n/* ---- /user_profile/wallet/* : center no-data vector while loading or empty ---- */\n.agce-wallet-page--initial .agce-wallet-empty-canvas {\n  min-height: min(70vh, 560px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.agce-wallet-page--initial .agce-wallet-empty-canvas .no-data-wrapper {\n  min-height: 200px;\n}\n\n.agce-wallet-empty-canvas__hint {\n  font-size: 14px;\n  color: #64748b;\n}\n\nbody:not(.light_theme) .agce-wallet-empty-canvas__hint {\n  color: #94a3b8;\n}\n\n/* Spot wallet: tablewrap has no .table-responsive; flex-fill so empty row can center */\n.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap:has(tr.no-data-row),\n.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap:has(tr.no-data-row2) {\n  display: flex;\n  flex-direction: column;\n  min-height: min(52vh, 420px);\n}\n\n.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap:has(tr.no-data-row) .funding-account__table,\n.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__tablewrap:has(tr.no-data-row2) .funding-account__table {\n  flex: 1 1 auto;\n  width: 100%;\n  min-height: min(48vh, 400px);\n}\n\n.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr.no-data-row td,\n.dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr.no-data-row2 td {\n  height: 100%;\n  min-height: min(46vh, 360px);\n  vertical-align: middle !important;\n  text-align: center !important;\n}\n\n.dashboard_right.funding-account.wallet-page--ao-popup tr.no-data-row .no-data-wrapper,\n.dashboard_right.funding-account.wallet-page--ao-popup tr.no-data-row2 .no-data-wrapper {\n  min-height: min(42vh, 320px);\n}\n\n/* Non-spot wallet: reinforce centering alongside global .table-responsive:has(.no-data-row) */\n.dashboard_right.funding-account.wallet-nonspot .dashboard_summary:has(tr.no-data-row),\n.dashboard_right.funding-account.wallet-nonspot .dashboard_summary:has(tr.no-data-row2) {\n  min-height: min(52vh, 420px);\n}\n\n.dashboard_right.funding-account.wallet-nonspot .dashboard_summary .table-responsive:has(tr.no-data-row),\n.dashboard_right.funding-account.wallet-nonspot .dashboard_summary .table-responsive:has(tr.no-data-row2) {\n  min-height: min(48vh, 400px);\n}\n\n.dashboard_right.funding-account.wallet-nonspot .dashboard_summary tr.no-data-row td,\n.dashboard_right.funding-account.wallet-nonspot .dashboard_summary tr.no-data-row2 td {\n  min-height: min(46vh, 360px);\n  vertical-align: middle !important;\n  text-align: center !important;\n}\n\n.dashboard_right.funding-account.wallet-nonspot tr.no-data-row .no-data-wrapper,\n.dashboard_right.funding-account.wallet-nonspot tr.no-data-row2 .no-data-wrapper {\n  min-height: min(42vh, 320px);\n}\n\n.margin-mmr-badge {\n  display: inline-block;\n  margin-top: 4px;\n  padding: 1px 6px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 4px;\n  background: #d1fae5;\n  color: #065f46;\n}\n\nbody.dark_theme .margin-mmr-badge {\n  background: #064e3b;\n  color: #6ee7b7;\n}\n\n/* Margin Pro Page - Ultra Premium Design (Pure CSS Override) */\n.margin-pro-page {\n  padding-top: 32px !important;\n  background: #ffffff00;\n}\n\nbody.light_theme .margin-pro-page {\n  background: #FFFFFF;\n}\n\n.margin-pro-page .funding-account__header {\n  margin: 24px 0 32px;\n  padding: 0;\n  border-bottom: none;\n}\n\n.margin-pro-page .funding-account__title {\n  font-size: 32px;\n}\n\n/* .margin-pro-page .funding-account__header>div:first-child::after {\n  content: \"Manage your isolated margin positions and assets\";\n  display: block;\n  font-size: 14px;\n  color: #707A8A;\n  margin-top: 4px;\n  font-weight: 400;\n} */\n\n.margin-pro-page .funding-account__pill {\n  background-color: #303135;\n  color: #FFFFFF;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.margin-pro-page .funding-account__pill::before {\n  filter: invert(0);\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23FFFFFF'%3E%3Cpath d='M16 16v-4l5 5-5 5v-4H4v-2h12zM8 2v3.999L20 6v2H8v4L3 7l5-5z'/%3E%3C/svg%3E\");\n  background-size: cover;\n}\n\nbody.light_theme .margin-pro-page .funding-account__pill::before {\n  filter: invert(1);\n}\n\n/* Summary Card Overrides */\n.margin-pro-page .funding-account__summarycard {\n  border: 1px solid #e5e7eb26;\n  background: #FFFFFF00;\n  border-radius: 12px;\n  padding: 24px;\n  margin: 0 0 24px 0;\n  box-shadow: none;\n}\n\nbody.light_theme .margin-pro-page .funding-account__summarycard {\n  border: 1px solid #EAECEF;\n  background: #FFFFFF;\n}\n\n.margin-pro-page .funding-account__summary-top {\n  margin-bottom: 16px;\n}\n\n.margin-pro-page .funding-account__totals-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #eeeeee;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\nbody.light_theme .margin-pro-page .funding-account__totals-label {\n  color: #1E2329;\n}\n\n.margin-pro-page .marginwallet_card {\n  align-items: center;\n  margin-top: 0;\n  gap: 0;\n}\n\n.margin-pro-page .funding-account__summary-main {\n  flex: 1;\n  /* border-right: 1px solid #EAECEF; */\n  padding-right: 24px;\n  margin-top: 0;\n}\n\n.margin-pro-page .funding-account__summary-amount {\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.margin-pro-page .funding-account__summary-num {\n  font-size: 32px;\n  font-weight: 700;\n  color: #f0f0f0;\n}\n\nbody.light_theme .margin-pro-page .funding-account__summary-num {\n  color: #1E2329;\n}\n\n.margin-pro-page .funding-account__summary-unit {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\nbody.light_theme .margin-pro-page .funding-account__summary-unit {\n  color: #1E2329;\n}\n\n.margin-pro-page .funding-account__summary-sub {\n  font-size: 13px;\n  color: #707A8A;\n  margin-bottom: 24px;\n}\n\n.margin-pro-page .funding-account__summary-pnl {\n  font-size: 13px;\n  color: #707A8A;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.margin-pro-page .funding-account__summary-pnl span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* .margin-pro-page .funding-account__summary-pnl span::after {\n  content: \"\";\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23707A8A'%3E%3Cpath d='M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z'/%3E%3C/svg%3E\");\n} */\n\n.margin-pro-page .funding-account__summary-pnl strong {\n  color: #F6465D;\n  font-weight: 500;\n}\n\n.margin-pro-page .funding-account__summary-grid {\n  flex: 1;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding-left: 24px;\n  gap: 0;\n}\n\n.margin-pro-page .funding-account__summary-stat {\n  display: flex;\n  width: 50%;\n  flex-direction: column;\n  text-align: left;\n  border-left: 1px solid #eaecef33;\n  padding-left: 40px;\n  padding-right: 30px;\n}\n\nbody.light_theme .margin-pro-page .funding-account__summary-stat {\n  border-left: 1px solid #EAECEF;\n}\n\n.margin-pro-page .funding-account__summary-stat-k {\n  font-size: 13px;\n  color: #f5f5f5;\n  margin-bottom: 12px;\n  font-weight: 400;\n}\n\nbody.light_theme .margin-pro-page .funding-account__summary-stat-k {\n  color: #1E2329;\n}\n\n.margin-pro-page .funding-account__summary-stat-v {\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 8px;\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\nbody.light_theme .margin-pro-page .funding-account__summary-stat-v {\n  color: #1E2329;\n}\n\n.margin-pro-page .funding-account__summary-stat-v span {\n  font-size: 12px;\n  color: #707A8A;\n  font-weight: 400;\n}\n\n.margin-pro-page .funding-account__summary-stat::after {\n  content: \"\";\n  display: block;\n  height: 2px;\n  border-radius: 2px;\n  width: 40px;\n  background-color: #c1c1c1;\n}\n\n.margin-pro-page .funding-account__summary-stat--right::after {\n  background-color: #EAECEF;\n}\n\n/* Filter Card Overrides */\n.margin-pro-page .funding-account__card {\n  background: none;\n  margin-top: 16px;\n  padding: 0;\n  box-shadow: none;\n}\n\n.margin-pro-page .funding-account__filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 18px;\n}\n\n.margin-pro-page .funding-account__search {\n  display: flex;\n  align-items: center;\n  border: 1px solid #EAECEF;\n  border-radius: 8px;\n  padding: 0 12px;\n  height: 36px;\n  background: #ffffff14;\n}\n\nbody.light_theme .margin-pro-page .funding-account__search {\n  background: #FFFFFF;\n}\n\n.margin-pro-page .funding-account__search i {\n  color: #707A8A;\n  font-size: 16px;\n  margin-right: 8px;\n}\n\n.margin-pro-page .funding-account__search input {\n  border: none;\n  outline: none;\n  width: 100%;\n  font-size: 13px;\n  color: #ebebeb;\n  background: transparent;\n}\n\nbody.light_theme .margin-pro-page .funding-account__search input {\n  color: #1E2329;\n}\n\n/* Custom checkbox */\n.margin-pro-page .funding-account__check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #d3d3d3;\n  user-select: none;\n  font-weight: 400;\n  margin-left: 24px;\n}\n\nbody.light_theme .margin-pro-page .funding-account__check {\n  color: #1E2329;\n}\n\n.margin-pro-page .funding-account__check input[type=\"checkbox\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  background-color: #FFFFFF;\n  border: 1px solid #B7BDC6;\n  border-radius: 4px;\n  position: relative;\n  cursor: pointer;\n  margin: 0;\n  transition: all 0.2s;\n}\n\n.margin-pro-page .funding-account__check:hover input[type=\"checkbox\"] {\n  border-color: #848E9C;\n}\n\n.margin-pro-page .funding-account__check input[type=\"checkbox\"]:checked {\n  background-color: #FCD535;\n  border-color: #FCD535;\n}\n\n.margin-pro-page .funding-account__check:last-child input[type=\"checkbox\"]:checked {\n  background-color: #1E2329;\n  border-color: #1E2329;\n}\n\n.margin-pro-page .funding-account__check input[type=\"checkbox\"]:checked::after {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  width: 4px;\n  height: 8px;\n  border: solid #1E2329;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.margin-pro-page .funding-account__check:last-child input[type=\"checkbox\"]:checked::after {\n  border-color: #FFFFFF;\n}\n\n\n/* Dark mode overrides */\nbody.dark .margin-pro-page,\nbody.dark .margin-pro-page .funding-account__summarycard,\nbody.dark .margin-pro-page .funding-account__card,\nbody.dark .margin-pro-page .funding-account__search {\n  background-color: #181A20;\n  border-color: #2B3139;\n}\n\nbody.dark .margin-pro-page .funding-account__title,\nbody.dark .margin-pro-page .funding-account__totals-label,\nbody.dark .margin-pro-page .funding-account__summary-num,\nbody.dark .margin-pro-page .funding-account__summary-unit,\nbody.dark .margin-pro-page .funding-account__summary-stat-k,\nbody.dark .margin-pro-page .funding-account__summary-stat-v,\nbody.dark .margin-pro-page .funding-account__check,\nbody.dark .margin-pro-page .funding-account__search input {\n  color: #EAECEF;\n}\n\nbody.dark .margin-pro-page .funding-account__summary-main,\nbody.dark .margin-pro-page .funding-account__filters {\n  border-color: #2B3139;\n}\n\nbody.dark .margin-pro-page .funding-account__pill {\n  background: #FCD535;\n  color: #181A20;\n}\n\n/* Table Styles (Matching Clean Design) */\n.margin-pro-page .funding-account__tablewrap {\n  background: transparent;\n  padding: 0;\n  margin-top: 16px;\n}\n\n.margin-pro-page .funding-account__table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.margin-pro-page .funding-account__table th {\n  padding: 10px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #8E939C;\n  border-bottom: none;\n  text-align: left;\n}\n\n.margin-pro-page .funding-account__table th:first-child {\n  padding-left: 16px;\n}\n\n.margin-pro-page .funding-account__table th:last-child {\n  padding-right: 16px;\n}\n\n.margin-pro-page .funding-account__table th.ta-r {\n  text-align: right;\n}\n\n.margin-pro-page .funding-account__table td {\n  padding: 16px 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  border-bottom: none;\n  vertical-align: middle;\n}\n\nbody.light_theme .margin-pro-page .funding-account__table td {\n  color: #1E2329;\n}\n\n.margin-pro-page .funding-account__table td:first-child {\n  padding-left: 16px;\n}\n\n.margin-pro-page .funding-account__table td:last-child {\n  padding-right: 16px;\n}\n\n.margin-pro-page .funding-account__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Pair & Coin Styling */\n.margin-pro-page .funding-account__coin-img {\n  width: 28px;\n  height: 28px;\n  margin-right: 0px;\n  border-radius: 50%;\n}\n\n.margin-pro-page .funding-account__pair {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1E2329;\n}\n\n.margin-pro-page .funding-account__coin-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #707A8A;\n}\n\n.margin-pro-page .funding-account__num {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e3e3e3;\n}\n\nbody.light_theme .margin-pro-page .funding-account__num {\n  color: #1E2329;\n}\n\nbody.dark .margin-pro-page .funding-account__pair .agce-margin-level-value {\n  color: inherit;\n}\n\n.margin-pro-page .funding-account__pair .agce-margin-level--normal,\n.margin-pro-page .funding-account__pair .agce-margin-level--safe {\n  color: #16a34a !important;\n}\n\n.margin-pro-page .funding-account__pair .agce-margin-level--margin_call {\n  color: #d97706 !important;\n}\n\n.margin-pro-page .funding-account__pair .agce-margin-level--liquidated {\n  color: #dc2626 !important;\n}\n\n.margin-pro-page .funding-account__pair .agce-margin-level--unavailable {\n  color: #9ca3af !important;\n}\n\n.margin-pro-page .margin-mmr-badge {\n  background: #E8F5E9;\n  color: #0CAF60;\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-top: 4px;\n  display: inline-block;\n}\n\n/* Action Buttons (Plain Text) */\n.margin-pro-page .funding-account__actions {\n  display: flex;\n  gap: 16px;\n  justify-content: flex-end;\n}\n\n.margin-pro-page .funding-account__action {\n  background: transparent;\n  border: none;\n  font-size: 12px;\n  /* font-weight: 600; */\n  color: #e9e9e9;\n  cursor: pointer;\n  padding: 0;\n}\n\nbody.light_theme .margin-pro-page .funding-account__action {\n  color: #262933;\n}\n\n.margin-pro-page .funding-account__action:hover {\n  text-decoration: underline;\n}\n\n/* Dark mode overrides for table */\nbody.dark .margin-pro-page .funding-account__table th {\n  color: #5E6673;\n  border-bottom-color: #2B3139;\n}\n\nbody.dark .margin-pro-page .funding-account__table td {\n  color: #EAECEF;\n  border-bottom-color: #2B3139;\n}\n\nbody.dark .margin-pro-page .funding-account__pair,\nbody.dark .margin-pro-page .funding-account__num {\n  color: #EAECEF;\n}\n\nbody.dark .margin-pro-page .funding-account__coin-name {\n  color: #848E9C;\n}\n\nbody.dark .margin-pro-page .funding-account__action {\n  color: #848E9C;\n}\n\nbody.dark .margin-pro-page .funding-account__action:hover {\n  color: #EAECEF;\n}\n\n\n/* ── Margin Borrow/Repay modal ─────────────────────────────── */\n.margin-modal-tabs {\n  display: flex;\n  gap: 24px;\n  align-items: flex-end;\n}\n\n.margin-modal-tab {\n  font-size: 18px;\n  font-weight: 700;\n  color: #aaa;\n  cursor: pointer;\n  /* padding-bottom: 2px; */\n}\n\n.margin-modal-tab--active {\n  font-weight: 700;\n  color: inherit;\n  /* border-bottom: 2px solid currentColor; */\n}\n\n.margin-modal-subtitle {\n  font-size: 13px;\n  color: #888;\n  margin-bottom: 4px;\n}\n\n.margin-modal-info-link {\n  font-size: 13px;\n  color: #1677ff;\n  display: inline-block;\n  margin-bottom: 16px;\n  text-decoration: none;\n}\n\n.margin-pair-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n/* ── Cross Margin Page Helper Classes (No Inline Styles) ─────────────────────────────── */\n.cmp-mb-4 {\n  margin-bottom: 4px;\n}\n\n.cmp-balance-val {\n  font-size: 28px;\n  line-height: 1.1;\n}\n\n.cmp-balance-val-mobile {\n  font-size: 26px;\n  line-height: 1.1;\n}\n\n.cmp-currency-label {\n  font-size: 14px;\n  color: #8E949E;\n}\n\n.cmp-balance-fiat {\n  font-size: 13px;\n  color: #8E949E;\n  margin-top: 2px;\n}\n\n.cmp-margin-gauge-label {\n  font-size: 12px;\n  color: #8E949E;\n  margin-bottom: 2px;\n  font-weight: 500;\n}\n\n.cmp-flex-center-gap-6 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cmp-cross-leverage {\n  font-size: 14px;\n  font-weight: 600;\n  color: #f59e0b;\n}\n\n.cmp-cross-leverage-mobile {\n  font-size: 13px;\n  font-weight: 600;\n  color: #f59e0b;\n}\n\n.cmp-risk-badge {\n  font-size: 11px;\n}\n\n.cmp-risk-badge-mobile {\n  font-size: 10px;\n}\n\n.cmp-stat-subtext {\n  font-size: 11px;\n  color: #8E949E;\n}\n\n.cmp-stat-val {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.cmp-text-danger {\n  color: #e45561 !important;\n}\n\n.cmp-text-warning {\n  color: #f59e0b !important;\n}\n\n.cmp-text-success {\n  color: #01bc8d !important;\n}\n\n.cmp-text-muted {\n  color: #8E949E !important;\n}\n\n.cmp-text-inherit {\n  color: inherit;\n}\n\n.cmp-mobile-row-divider {\n  border-top: 1px solid rgba(128, 128, 128, 0.12);\n  padding-top: 14px;\n}\n\n.cmp-mobile-margin-gauge-title {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.cmp-mobile-margin-gauge-val {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.cmp-pnl-title {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.cmp-pnl-btn-group {\n  display: flex;\n  gap: 4px;\n}\n\n.cmp-pnl-btn {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: none;\n  background: rgba(128, 128, 128, 0.12);\n  color: #8E949E;\n  cursor: pointer;\n}\n\n.cmp-pnl-btn.active {\n  background: #0f172a;\n  color: #fff;\n}\n\nbody.dark .cmp-pnl-btn.active {\n  background: #fff;\n  color: #000;\n}\n\n.cmp-pnl-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 16px;\n}\n\n.cmp-pnl-label {\n  font-size: 11px;\n  color: #ebebeb;\n}\n\nbody.light_theme .cmp-pnl-label {\n  color: #8E949E;\n}\n\n.cmp-pnl-val {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.cmp-pnl-footer {\n  grid-column: 1 / -1;\n  font-size: 11px;\n  color: #8E949E;\n  margin-top: 2px;\n}\n\n.cmp-loading-text {\n  font-size: 12px;\n  color: #8E949E;\n}\n\n.cmp-flex-1-center {\n  flex: 1;\n  justify-content: center;\n}\n\n.cmp-mobile-actions-row {\n  display: flex;\n  gap: 10px;\n}\n\n.cmp-tabs-header {\n  /* border-bottom: 1px solid rgba(128, 128, 128, 0.15); */\n  padding: 0 0px;\n}\n\n.cmp-tabs-group {\n  display: flex;\n  gap: 20px;\n}\n\n.cmp-tab-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #ffffff8c;\n  padding: 12px 0px 10px;\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: capitalize;\n}\n\nbody.light_theme .cmp-tab-btn {\n  color: #242424;\n}\n\n.cmp-tab-btn.active {\n  font-weight: 600;\n  color: inherit;\n}\n\n.cmp-py-8 {\n  padding: 8px 0;\n}\n\n.cmp-search-box {\n  min-width: 160px;\n}\n\n.cmp-mobile-filter-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 8px 0;\n}\n\n.cmp-w-100 {\n  width: 100%;\n}\n\n.cmp-checkbox-label {\n  font-size: 15px;\n}\n\n.cmp-mobile-filter-actions {\n  display: flex;\n  gap: 10px;\n  padding-top: 10px;\n}\n\n.so-filtersModal--filters .modal-footer {\n  border: none;\n  padding: 20px;\n}\n\n.so-filtersModal--filters .modal-body {\n  padding: 20px;\n}\n\n.so-filtersModal--filters .modal-header {\n  padding: 20px 20px 10px;\n  border: none;\n}\n\n.modal.agce-ao-sheet-modal .agce-ao-sheet__header {\n  border-bottom: none;\n}\n\n.modal.agce-ao-sheet-modal .agce-ao-sheet__divider {\n  display: none;\n}\n\n.modal.agce-ao-sheet-modal .agce-ao-sheet__kv {\n  font-size: 14px;\n}\n\n.modal.agce-ao-sheet-modal .agce-ao-sheet__hero-num {\n  font-size: 24px;\n  margin-bottom: 18px;\n}\n\n.cmp-flex-1 {\n  flex: 1;\n}\n\n.cmp-table-wrap {\n  min-height: 320px;\n}\n\n.cmp-interest-badge {\n  color: #e45561;\n  font-size: 11px;\n}\n\n.cmp-borrowed-val.has-borrow {\n  color: #e45561;\n}\n\n.cmp-relative-inline {\n  position: relative;\n  display: inline-block;\n}\n\n.cmp-help-text {\n  cursor: help;\n  color: #8e949e;\n  font-size: 13px;\n  padding: 8px 4px;\n  display: inline-block;\n}\n\n.cmp-close-btn {\n  color: #e45561 !important;\n  border-color: #e45561 !important;\n  cursor: pointer;\n  pointer-events: auto;\n}\n\n.cmp-close-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.cmp-side-badge {\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 3px;\n  padding: 1px 5px;\n}\n\n.cmp-side-badge--long {\n  color: #01bc8d;\n  border: 1px solid #01bc8d;\n}\n\n.cmp-side-badge--short {\n  color: #e45561;\n  border: 1px solid #e45561;\n}\n\n.cmp-z-1060 {\n  z-index: 1060;\n}\n\n.margin-coin-radios {\n  display: flex;\n  gap: 24px;\n  margin: 12px 0;\n}\n\n.funding-account__summarycard.border-0 {\n  padding: 0px;\n  border-radius: 0px;\n}\n\n.crossmargintop {\n  border: 1px solid #e5e7eb26;\n  border-radius: 12px;\n  background: #ffffff00;\n  padding: 24px;\n  margin: 0 0 24px 0;\n  box-shadow: none;\n}\n\nbody.light_theme .crossmargintop {\n  border: 1px solid #EAECEF;\n  background: #FFFFFF;\n}\n\n.funding_acount_block_margin {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  border: 1px solid #eaecef29;\n  border-radius: 12px;\n  background: #ffffff00;\n  padding: 24px;\n  margin: 0 0 24px 0;\n  box-shadow: none;\n}\n\nbody.light_theme .funding_acount_block_margin {\n  border: 1px solid #EAECEF;\n  background: #FFFFFF;\n}\n\n.so-filtersModal--filters {\n  backdrop-filter: blur(5px);\n}\n\n.modal-content {\n  box-shadow: 0px 5px 15px #00000026;\n  border: var(--bs-modal-border-width) solid rgb(0 0 0 / 9%);\n}\n\n.margin-coin-radio {\n  color: rgb(230, 230, 230);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\nbody.light_theme .margin-coin-radio {\n  color: #0f172a;\n}\n\n.margin-info-rows {\n  margin-bottom: 12px;\n  margin-top: 18px;\n\n}\n\n.margin-info-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  color: #888;\n  margin-bottom: 6px;\n}\n\n.margin-info-row span:last-child {\n  color: inherit;\n}\n\n.margin-pairs-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0;\n}\n\n.margin-pairs-header h6 {\n  margin-bottom: 0;\n}\n\n.margin-hide-zero {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #888;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n\n.margin-modal-note {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  background: #2B313C;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 12px;\n  color: #f7f7f7;\n  margin: 16px 0;\n}\n\nbody.light_theme .margin-modal-note {\n  color: #505050;\n  background: #e5e5e5;\n}\n\n.funding-account__totals-label button i {\n  color: #fff;\n}\n\nbody.light_theme .funding-account__totals-label button i {\n  color: #000;\n}\n\n.margin-modal-note i {\n  color: #3b82f6;\n  font-size: 16px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.margin-modal-actions {\n  display: flex;\n  gap: 16px;\n}\n\n.crypto_selectcoin-2 {\n  margin-top: 15px !important;\n}\n\n.margin-modal-btn-cancel,\n.margin-modal-btn-confirm {\n  /* flex: 1; */\n  border-radius: 40px;\n  padding: 10px 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.margin-modal-btn-cancel {\n  background: #f3f4f6;\n  color: #222;\n  border: none;\n}\n\n.margin-modal-btn-confirm {\n  background: #f3f4f6;\n  color: #222;\n  border: none;\n}\n\n.margin-modal-btn-confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\nbody.dark_theme .margin-modal-btn-cancel,\nbody.dark_theme .margin-modal-btn-confirm {\n  background: #2d3748;\n  color: #e2e8f0;\n}\n\n.margin-modal-interest-note {\n  font-size: 12px;\n  color: #888;\n  line-height: 1.5;\n  padding: 6px 0 2px;\n}\n\nbody.dark_theme .margin-modal-interest-note {\n  color: #9ca3af;\n}\n\n.margin-level-value {\n  color: #22c55e;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.margin-tier-value {\n  color: #f59e0b;\n  font-weight: 600;\n}\n\n.margin-pair-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: #2d3138;\n  border: 1px solid #ededed05;\n  border-radius: 8px;\n  z-index: 9999;\n  max-height: 200px;\n  overflow-y: auto;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);\n}\n\nbody.light_theme .margin-pair-dropdown {\n  background: #fff;\n  border: 1px solid #ededed;\n}\n\n.margin-pair-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background 0.15s;\n}\n\n.margin-pair-option:hover {\n  background: #f5f5f514;\n}\n\nbody.light_theme .margin-pair-option:hover {\n  background: #f5f5f5;\n}\n\n.margin-pair-option--active {\n  background: #f5f5f514;\n  font-weight: 600;\n}\n\nbody.light_theme .margin-pair-option--active {\n  background: #f0f0f0;\n}\n\ndiv#marginBorrowRepayModal .modal-content {\n  min-height: 550px;\n}\n\nbody.dark_theme .margin-pair-dropdown {\n  background: #1a1d27;\n  border-color: #2d3748;\n}\n\nbody.dark_theme .margin-pair-option:hover {\n  background: #2d3748;\n}\n\nbody.dark_theme .margin-pair-option--active {\n  background: #2a2f3e;\n}\n\n/* No-liability / tooSmall tooltip */\n.agce-no-liab-wrap {\n  position: relative;\n  display: inline-block;\n}\n\n.agce-no-liab-tip {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  top: calc(100% + 8px);\n  bottom: auto;\n  right: 0;\n  left: auto;\n  transform: none;\n  background: #1e293b;\n  color: #f1f5f9;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: normal;\n  width: 220px;\n  padding: 8px 12px;\n  border-radius: 7px;\n  pointer-events: none;\n  z-index: 99999;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);\n  text-align: center;\n  line-height: 1.55;\n  transition: opacity 0.15s ease;\n}\n\n.agce-no-liab-tip::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  right: 16px;\n  left: auto;\n  transform: none;\n  border: 6px solid transparent;\n  border-bottom-color: #1e293b;\n}\n\n.agce-no-liab-wrap:hover .agce-no-liab-tip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.margin-modal-container .coin-icon-small span.coin-icon-text {\n  color: #000 !important;\n}\n\n\n/*\n * Margin account (/user_profile/wallet/margin): compact card layout on mobile.\n * Show only Pair (td:nth-child(1)) + Net Assets (td:nth-child(8)) columns.\n * td:nth-child(8) contains the ⋮ button for full-detail popup.\n */\n\n\n@media (max-width: 1440px) {\n\n  .dashboard_right.funding-account {\n    padding: 24px 38px 32px 50px;\n  }\n\n  .funding-account__title {\n    font-size: 32px;\n  }\n\n}\n\n@media (max-width: 1366px) {\n\n  .funding-account__title {\n    font-size: 32px;\n  }\n\n}\n\n\n@media (max-width: 1200px) {\n\n  .funding-account__title {\n    font-size: 24px;\n  }\n\n  .funding-account__pill {\n    padding: 6px 16px;\n    font-size: 14px;\n  }\n\n  .funding-account__totals-num {\n    font-size: 24px;\n  }\n\n  .margin-pro-page .funding-account__title {\n    font-size: 26px;\n  }\n\n}\n\n@media (max-width: 991.98px) {\n  .funding-account__header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .funding-account__toprow {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  /* .funding-account__summary-grid {\n    grid-template-columns: 1fr;\n  } */\n\n  .dashboard_right.funding-account {\n    padding: 15px 20px 24px 20px;\n  }\n\n  /* Mobile: turn table into card list */\n  .funding-account__tablewrap {\n    overflow: visible;\n    background: transparent;\n  }\n\n  .funding-account__table {\n    min-width: 0 !important;\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 12px;\n    /* vertical gaps between cards */\n  }\n\n  .funding-account__table thead {\n    display: none;\n  }\n\n  .funding-account__header {\n    margin: 0px 0 8px;\n  }\n\n  /* .funding-account__table tbody,\n  .funding-account__table tr,\n  .funding-account__table td {\n    display: block;\n    width: 100%;\n  } */\n\n  .funding-account__table tbody tr {\n    overflow: hidden;\n\n  }\n\n  .funding-account__table tbody td {\n    padding: 12px 2px;\n    border-top: none;\n  }\n\n  .funding-account__table thead th {\n    padding: 12px 2px;\n  }\n\n  .funding-account__table tbody td:first-child {\n    border-top: 0;\n  }\n\n  .funding-account__table tbody td[data-label] {\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 14px;\n  }\n\n  .funding-account__table tbody td[data-label]::before {\n    display: none;\n  }\n\n  .funding-account__table tbody td[data-label]>* {\n    text-align: right;\n  }\n\n  /* Prevent long values/actions from being clipped */\n  .funding-account__table tbody td[data-label]>* {\n    min-width: 0;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n\n  .funding-account__table tbody td[data-label=\"Coin\"]>* {\n    text-align: left;\n  }\n\n  /* Standalone Funding page: same compact table rows as Asset Overview (wallet-page--ao-popup + assetOverview.css) */\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr {\n    border-bottom: 1px solid #f1f5f9;\n  }\n\n  .dashboard_right.funding-account.wallet-page--ao-popup .funding-account__table tbody tr:last-child {\n    border-bottom: none;\n  }\n\n  .funding-account__coin>div {\n    min-width: 0;\n  }\n\n  .funding-account__actions {\n    justify-content: flex-end;\n    gap: 12px;\n  }\n\n  .funding-account__action {\n    font-size: 13px;\n  }\n\n  .funding-account__search {\n    min-width: 0;\n    width: 250px;\n  }\n\n  /*\n   * Futures account (/user_profile/wallet/futures): override card-list table above.\n   * Asset Overview–style rows: real table, thead hidden, two columns + ⋮ (see FuturesAccountPage).\n   */\n  .dashboard_right.funding-account.futures-account-page .funding-account__tablewrap {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    background: transparent;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures,\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets {\n    min-width: 0 !important;\n    width: 100%;\n    border-collapse: collapse !important;\n    border-spacing: 0 !important;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures thead,\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets thead {\n    display: none !important;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody,\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody {\n    display: table-row-group !important;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody tr,\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody tr {\n    display: table-row !important;\n    background: transparent !important;\n    border: none !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    margin-bottom: 0 !important;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody td,\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody td {\n    display: table-cell !important;\n    width: auto !important;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody td[data-label]::before,\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody td[data-label]::before {\n    display: none !important;\n    content: none !important;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures thead th:nth-child(n + 3),\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures tbody td:nth-child(n + 3),\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets thead th:nth-child(n + 3),\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody td:nth-child(n + 3) {\n    display: none !important;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions {\n    min-width: 1180px;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions thead {\n    display: table-header-group !important;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions thead th,\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions tbody td {\n    display: table-cell !important;\n  }\n\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-positions tbody tr:first-child td,\n  .dashboard_right.funding-account.futures-account-page .funding-account__table--futures-assets tbody tr:first-child td {\n    border-top: none;\n  }\n\n\n  .funding-account__table--margin tbody,\n  .funding-account__table--margin tbody tr,\n  .funding-account__table--margin tbody td {\n    display: block;\n    width: 100%;\n  }\n\n  .funding-account__coin-name {\n    font-size: 12px;\n    font-weight: 400;\n  }\n\n  .funding-account__table--margin tbody tr {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 0;\n    border-bottom: 1px solid #f1f5f921;\n    background: transparent !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    margin-bottom: 0 !important;\n  }\n\n  .funding-account__table--margin tbody tr:last-child {\n    border-bottom: none;\n  }\n\n  /* Hide: Coin, Available, Borrowable, Loan Cap, Borrowed, Frozen, Est. Liq, Action */\n  .funding-account__table--margin tbody td:nth-child(2),\n  .funding-account__table--margin tbody td:nth-child(3),\n  .funding-account__table--margin tbody td:nth-child(4),\n  .funding-account__table--margin tbody td:nth-child(5),\n  .funding-account__table--margin tbody td:nth-child(6),\n  .funding-account__table--margin tbody td:nth-child(7),\n  .funding-account__table--margin tbody td:nth-child(9),\n  .funding-account__table--margin tbody td:nth-child(10) {\n    display: none !important;\n  }\n\n  /* Pair cell: left-aligned, take available width */\n  .funding-account__table--margin tbody td:nth-child(1) {\n    width: auto;\n    flex: 1 1 auto;\n    padding: 0;\n    border: none;\n    text-align: left;\n  }\n\n  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin {\n    gap: 10px;\n  }\n\n  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin-img {\n    width: 36px;\n    height: 36px;\n  }\n\n  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin span {\n    font-size: 15px;\n    font-weight: 600;\n  }\n\n  .funding-account__table--margin tbody td:nth-child(1) .margin-mmr-badge {\n    display: none;\n  }\n\n  /* Net Assets cell: right-aligned */\n  .funding-account__table--margin tbody td.margin-acct__net-cell {\n    width: auto;\n    flex: 0 0 auto;\n    padding: 0;\n    border: none;\n    text-align: right;\n  }\n\n  .margin-acct__filters {\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n\n  .margin-acct__filters .funding-account__search {\n    min-width: 0;\n    width: 100%;\n    flex: 1 1 100%;\n  }\n\n  .margin-acct__filters .funding-account__check {\n    font-size: 13px;\n    gap: 6px;\n    white-space: nowrap;\n  }\n\n  .margin-pro-page .funding-account__header {\n    margin: 0px 0 24px;\n  }\n\n  .margin-pro-page .funding-account__title {\n    font-size: 24px;\n  }\n\n\n}\n\n@media (max-width: 767px) {\n\n  .funding-account__title {\n    font-size: 22px;\n  }\n\n  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin span {\n    font-size: 13px;\n  }\n\n  div#marginBorrowRepayModal .modal-content {\n    min-height: 50vh;\n    max-height: 70vh;\n  }\n\n  .dashboard_right.funding-account {\n    width: 100%;\n  }\n\n  .funding-account__action {\n    font-size: 12px;\n  }\n\n  .dashboard_right.funding-account.margin-pro-page {\n    padding-top: 16px !important;\n  }\n\n  .margin-pro-page .funding-account__title {\n    font-size: 20px;\n  }\n\n  .margin-pro-page .funding-account__summary-num {\n    font-size: 24px;\n  }\n\n  .margin-pro-page .marginwallet_card {\n    flex-direction: column;\n  }\n\n  .margin-pro-page .funding-account__summary-main {\n    padding-right: 0px;\n    width: 100%;\n  }\n\n  .margin-pro-page .funding-account__summary-stat {\n    padding-left: 0px;\n    padding-right: 20px;\n    /* border-right: 1px solid #EAECEF; */\n    border-left: none;\n  }\n\n  .margin-pro-page .funding-account__summary-grid {\n    padding-left: 0px;\n    width: 100%;\n  }\n\n  .so-filtersModal--filters .modal-footer {\n    border: none;\n    padding: 0px 20px 10px;\n  }\n\n  .so-filtersModal--filters .modal-footer button {\n    font-size: 14px;\n  }\n\n  .funding-account__actions {\n    gap: 6px;\n  }\n\n  .funding-account__summary-num {\n    font-size: 22px;\n  }\n\n  .funding-account__pill {\n    padding: 7px 11px;\n  }\n\n  .margin-pro-page .funding-account__filters {\n    padding: 16px 0px;\n  }\n\n  .margin-pro-page .funding-account__table td:first-child {\n    padding-left: 0px;\n  }\n\n  .modal.agce-ao-sheet-modal .agce-ao-sheet__hero-num {\n    font-size: 18px;\n  }\n\n  .margin-modal-actions .btn {\n    padding: 9px !important;\n    font-size: 13px !important;\n  }\n\n  .agce-ao-sheet-dialog .agce-ao-sheet__body {\n    padding-bottom: 0px !important;\n  }\n\n  .margin_pnl_bl {\n    flex-direction: column;\n  }\n\n  .funding_acount_block_margin {\n    padding: 20px;\n    margin: 0 0 0px 0;\n  }\n\n\n  .margin-modal-container .margin-modal-tab-wrapper {\n    font-size: 15px;\n  }\n\n  .cmp-mobile-row-divider {\n    border-top: none;\n    padding-top: 14px;\n    width: 100%;\n    border: 1px solid #eaecef2b;\n    border-radius: 12px;\n    padding: 20px;\n    margin: 0 0 0px 0 !important;\n    box-shadow: none;\n  }\n\n  body.light_theme .cmp-mobile-row-divider {\n    border: 1px solid #EAECEF;\n  }\n\n  .cmp-stat-val {\n    font-size: 15px;\n  }\n\n  .d-md-none.mt-3.cmp-mobile-row-divider.buttons_row {\n    margin-top: 24px !important;\n  }\n\n  .funding-account__summary-stat-k {\n    font-size: 12px;\n  }\n\n  .agce-ao-sheet__table-actions .btn-link,\n  .agce-ao-sheet__table-actions .funding-account__action,\n  .agce-ao-sheet__table-actions .funding-account__action--btn {\n    min-height: 36px;\n    padding: 7px 10px;\n    font-size: 13px;\n  }\n\n  .margin-pro-page .funding-account__summary-top {\n    margin-bottom: 5px;\n  }\n\n  .margin-pro-page .funding-account__summary-sub {\n    margin-bottom: 15px;\n  }\n\n  .margin-pro-page .funding-account__summarycard {\n    padding: 15px;\n    margin: 0 0 15px 0;\n  }\n\n  .margin-pro-page .funding-account__pill {\n    padding: 8px 20px;\n    font-size: 13px;\n  }\n\n  .funding-account__summary-pnl {\n    font-size: 13px;\n  }\n\n  .funding-account__table--margin tbody td:nth-child(1) .funding-account__coin-img {\n    width: 24px;\n    height: 24px;\n  }\n\n  .cmp-mobile-filter-body .funding-account__search.cmp-w-100 {\n    width: 100%;\n  }\n\n}\n\n\n@media (max-width: 580px) {\n\n  .funding-account__search {\n    width: 180px;\n  }\n\n  .margin-acct__filters .funding-account__check {\n    font-size: 12px;\n  }\n\n  .funding-account__check {\n    font-size: 12px;\n  }\n\n  .margin-modal-legend {\n    font-size: 13px !important;\n  }\n\n  .cmp-checkbox-label {\n    font-size: 13px;\n  }\n\n  .so-filtersModal--filters .modal-body {\n    padding: 5px 20px 10px !important;\n  }\n\n  .funding-account__title {\n    font-size: 20px;\n  }\n\n  .funding-account__summary-num {\n    font-size: 18px;\n  }\n\n  .modal.agce-ao-sheet-modal .agce-ao-sheet__kv {\n    font-size: 12px;\n    padding: 5px 0;\n  }\n\n  .funding-account__subnum {\n    font-size: 12px;\n  }\n\n  .funding-account__pill {\n    font-size: 12px;\n  }\n\n}\n\n/* Options wallet — summary card action buttons (override margin-pro-page pill defaults) */\n.options-account-page.margin-pro-page .funding-account__summarycard .options-account__summary-actions {\n  display: flex;\n  flex-direction: column;\n  margin-top: 12px;\n  gap: 10px;\n  align-self: center;\n  margin-left: auto;\n  min-width: 168px;\n}\n\n.options-account-page.margin-pro-page .funding-account__summarycard .options-account__summary-actions .funding-account__pill {\n  width: 100%;\n  margin: 0;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  justify-content: center;\n  background-image: none;\n}\n\n.options-account-page.margin-pro-page .funding-account__summarycard .options-account__summary-actions .funding-account__pill::before {\n  content: none;\n  display: none;\n}\n\n.options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-transfer {\n  background-color: #292b30;\n  color: #fff;\n}\n\nbody.light_theme .options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-transfer {\n  color: #000;\n  background-color: #ededed;\n}\n\n.options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-history {\n  background-color: #ededed14;\n  color: #ffffff;\n}\n\n\nbody.light_theme .options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-history {\n  background-color: #EDEDED;\n  color: #1E2329;\n}\n\n.options-account-page.margin-pro-page .funding-account__totals-label::after {\n  content: none;\n  display: none;\n}\n\n.options-account-page .funding-account__action,\n.options-account-page .funding-account__action--btn {\n  color: #d1aa67;\n}\n\nbody.dark .options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-transfer {\n  background-color: #FCD535;\n  color: #181A20;\n}\n\nbody.dark .options-account-page.margin-pro-page .funding-account__summarycard .options-account__btn-history {\n  background-color: #2B3139;\n  color: #EAECEF;\n}\n\n/* Mobile Card View for Options Account Page */\n@media (max-width: 991.98px) {\n  .dashboard_right.funding-account.options-account-page .funding-account__tablewrap {\n    overflow-x: hidden;\n    background: transparent;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table thead {\n    display: none !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table,\n  .dashboard_right.funding-account.options-account-page .funding-account__table tbody,\n  .dashboard_right.funding-account.options-account-page .funding-account__table tr,\n  .dashboard_right.funding-account.options-account-page .funding-account__table td {\n    display: block !important;\n    width: 100% !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table tr {\n    margin-bottom: 16px !important;\n    border: 1px solid #f3f4f61f !important;\n    border-radius: 12px !important;\n    padding: 12px 16px !important;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n  }\n\n  body.light_theme .dashboard_right.funding-account.options-account-page .funding-account__table tr {\n    border-color: #F3F4F6 !important;\n    background: #ffffff !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table tr.no-data-row,\n  .dashboard_right.funding-account.options-account-page .funding-account__table tr.no-data-row td {\n    display: block !important;\n    border: none !important;\n    background: transparent !important;\n    box-shadow: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table tr.no-data-row td::before {\n    display: none !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table td {\n    display: flex !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding: 10px 0 !important;\n    border-top: none !important;\n    text-align: right !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table td::before {\n    content: attr(data-label);\n    font-size: 13px;\n    color: #8E939C;\n    display: block !important;\n    text-align: left;\n    margin-right: 16px;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table td:first-child {\n    border-bottom: 1px solid #f3f4f61f !important;\n    padding-bottom: 12px !important;\n    margin-bottom: 4px !important;\n    justify-content: flex-start !important;\n  }\n\n  body.light_theme .dashboard_right.funding-account.options-account-page .funding-account__table td:first-child {\n    border-bottom-color: #F3F4F6 !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table td:first-child::before {\n    display: none !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table td>* {\n    text-align: right;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label=\"Action\"] {\n    margin-top: 8px !important;\n    padding-top: 12px !important;\n    border-top: 1px dashed #f3f4f61f !important;\n    justify-content: center !important;\n  }\n\n  body.light_theme .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label=\"Action\"] {\n    border-top-color: #F3F4F6 !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label=\"Action\"]::before {\n    display: none !important;\n  }\n\n  .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label=\"Action\"] .funding-account__action {\n    background: #d1aa67;\n    color: #fff;\n    padding: 6px 24px;\n    border-radius: 6px;\n    font-weight: 500;\n    text-decoration: none;\n    display: inline-block;\n  }\n\n  body.light_theme .dashboard_right.funding-account.options-account-page .funding-account__table td[data-label=\"Action\"] .funding-account__action {\n    background: #d1aa67;\n    color: #fff;\n  }\n}\n\n@media (max-width: 767px) {\n\n  body.light_theme .margin-pro-page .funding-account__summary-stat {\n    border-left: none;\n  }\n\n  .funding-account__filters.rightsearch {\n    justify-content: space-between;\n  }\n\n  .margin-pro-page .funding-account__check {\n    margin-left: 12px;\n  }\n\n  .funding-account__table tbody td {\n    padding: 8px 2px;\n  }\n\n  .options-account-page.margin-pro-page .funding-account__header-actions.options-account__summary-actions {\n    min-width: 100%;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .options-account-page.margin-pro-page .funding-account__header-actions.options-account__summary-actions .funding-account__pill {\n    width: auto;\n  }\n\n  .margin-pro-page .funding-account__summary-stat {\n    border-left: none;\n  }\n\n  .options-account-page.margin-pro-page .funding-account__summarycard .options-account__summary-actions .funding-account__pill {\n    padding: 7px 20px;\n    font-size: 12px;\n  }\n\n\n}\n\nspan.badge.cmp-risk-badge-mobile.bg-success {\n  color: #fff;\n  z-index: 0;\n  background: #3a3a3a !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
